"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingPaymentStatus = exports.BookingInvoiceContactTypeInput = exports.BookingDiscountType = exports.BookingDiscountStatus = exports.BookingApprovalStatus = exports.BookingAccessControlHistoryEventType = exports.BookingAccessControlCodeStatus = exports.BookableResourceStatus = exports.BookableResourcePaymentMethod = exports.BookableResourceFeatureType = exports.BookableResourceCancellationRateType = exports.BookableResourceBookingApprovalType = exports.BookableResourceAvailabilityType = exports.BookableResourceAddOnType = exports.BillingCustomerType = exports.BarcodeType = exports.AvatarImageType = exports.AuthRole = exports.AttendanceUpdate = exports.AssociationValidationRule = exports.ArticleApiRole = exports.AppointmentsViewScope = exports.AppleStoreStatus = exports.ApartmentSortField = exports.AiRole = exports.AdminUiWidgetType = exports.AdminSocialLinkType = exports.AdminRole = exports.AdminRegistrationType = exports.AdminProfileStatus = exports.AdminPlatformType = exports.AdminParkingProvider = exports.AdminImageType = exports.AdminFeatureModuleType = exports.AdminDestinationStatus = exports.AdminClientRegion = exports.AdminAccessControlSystem = exports.AdminAccessControlSolution = exports.ActivitySortField = exports.ActivityRole = exports.ActivityChangeFieldType = exports.ActivityAudience = exports.AccessPassSystem = exports.AccessPassMethod = exports.AccessControlSystem = exports.AccessControlSolution = exports.Ac1QrCodeGenerator = exports.Ac1IntegrationCredentialSetupOwnerTypes = exports.Ac1CredentialSetupCategory = exports.Ac1AccessGroupKind = void 0;
exports.DocumentRootPrefixType = exports.DocumentRole = exports.DocumentContentDisposition = exports.DnsRecordType = exports.DnsCheckStatus = exports.DiscountType = exports.DiscountStatus = exports.DestinationType = exports.DestinationTierLevel = exports.DestinationStatus = exports.DestinationAppId = exports.DeliveryType = exports.DealVendorSortableFields = exports.DealType = exports.DayOfTheWeek = exports.DateFilterOperatorV3 = exports.DataType = exports.CreditTransactionsQueryRole = exports.CreditTransactionType = exports.CreditSubAccountType = exports.CreditStatsQueryRole = exports.CreditRole = exports.CreditProviderType = exports.CreditCustomerType = exports.CreditAccountType = exports.CortexEnricherRole = exports.CortexEnricherProfileRegistrationType = exports.CortexEnricherContentType = exports.ContentType = exports.ContentSortType = exports.ContentRestrictionLevel = exports.ContentInteractionType = exports.ContentFeaturedLevel = exports.CompanyV2SortField = exports.CommentOperationType = exports.CollectionContentType = exports.ClientRegion = exports.ChoicesSearchBy = exports.CheckoutFailureCodesV2 = exports.CheckoutFailureCodes = exports.ChangePasswordErrorCode = exports.CardBrand = exports.CancellingUserRole = exports.CacheControlScope = exports.CmsArticleStatus = exports.BpVisitorSortField = exports.BpAppointmentSortField = exports.BookingsRole = exports.BookingStatus = exports.BookingSortOrder = void 0;
exports.PropertyManagerEquiemOneMetrics = exports.ProfileStatus = exports.ProfileSortField = exports.ProfileRole = exports.ProfileRegistrationType = exports.ProfileReadyCheckStatus = exports.ProfileHistorySortField = exports.ProfileEventLogAction = exports.ProductVisibility = exports.ProductType = exports.ProductSubscriptionStatusV2 = exports.ProductSubscriptionStatus = exports.PollQuestionType = exports.PollDurationInterval = exports.PolicyChangeEventLogAction = exports.PlatformType = exports.PaymentIntentStatus = exports.PaymentFailureCodes = exports.ParkingProvider = exports.PageViewPageType = exports.OtpChallengeRespondFailureReason = exports.OtpChallengeFailureReason = exports.OrderStatus = exports.OperationsRole = exports.OpeningType = exports.OnSiteStatus = exports.OccurrenceType = exports.MySpacesQueryRole = exports.ModType = exports.MetricUnit = exports.LinkTrackType = exports.LikeOperationType = exports.InviteStatus = exports.InviteSortField = exports.InviteHistoryAction = exports.InteractionsRole = exports.InfrastructureGroupStatus = exports.InactivityUnit = exports.ImageType = exports.ImagePreset = exports.GoogleStoreStatus = exports.FlexTenantStatus = exports.FeedbackMetricTargetType = exports.FeedbackFormat = exports.FeatureModulesFilterValue = exports.FeatureModuleType = exports.EventCheckInFailureReason = exports.EquiemOneWidgetId = exports.EmailStatus = exports.DomainServiceRole = void 0;
exports.VisitorInfo = exports.VisitorAppointmentsSortField = exports.VisitorAppointmentsQueryRole = exports.VisitorAppointmentWeekday = exports.VisitorAppointmentType = exports.VisitorAppointmentRecurringType = exports.ViciniteeRole = exports.VendorVisibilityStatus = exports.VendorSortableFields = exports.VendorProductsSearchBy = exports.ValidateResetPasswordErrorCode = exports.ValidateBookingTimesStatus = exports.UserSortFieldV2 = exports.UserSortField = exports.UserRole = exports.UserIndexFieldGroups = exports.UiWidgetType = exports.TabName = exports.SyndicateRole = exports.SyncStatus = exports.SwiftConnectSdkType = exports.SubscriptionPaymentStatus = exports.SubscriptionBillingCycle = exports.StoreUserPermission = exports.StoreRole = exports.StepStatus = exports.StatsProviderVisitorType = exports.StatsProviderVisitorAppointmentType = exports.SpaceVisibilityType = exports.SocialLinkType = exports.SmsChallengeRespondFailureReason = exports.SmsChallengeFailureReason = exports.SegmentationRole = exports.SegmentationRegistrationType = exports.SegmentationFilterItemType = exports.SearchContentType = exports.Role = exports.ReqMgtStatusType = exports.ReqMgtSortField = exports.ReqMgtRole = exports.ReqMgtRequestsFilterScope = exports.ReqMgtPriority = exports.ReqMgtFiltersQueryRole = exports.ReqMgtCafmConfigurationType = exports.ReqMgtBuildingsQueryRole = exports.RegistrationType = exports.RefundBookingItemType = exports.PublicationDateType = exports.PublicationAuthorType = exports.PubSubRole = void 0;
exports.getSdk = exports.StoreUserLocalePreferenceDocument = exports.LocalePreferenceDocument = exports.WorkRequestRole = exports.WhitelabelStatus = exports.Weekday = exports.WebAppApplication = exports.VmsVendorVisibilityStatus = exports.VmsVendorSortableFields = exports.VmsVendorProductsSearchBy = exports.VmsSubscriptionPaymentStatus = exports.VmsSubscriptionBillingCycle = exports.VmsStoreUserPermission = exports.VmsStepStatus = exports.VmsSortOrder = exports.VmsReportingCategory = exports.VmsProductVisibility = exports.VmsProductType = exports.VmsProductSubscriptionStatusV2 = exports.VmsProductSubscriptionStatus = exports.VmsPolicyType = exports.VmsPermissionType = exports.VmsPaymentIntentStatus = exports.VmsPaymentFailureCodes = exports.VmsPauseOrResumeSubscriptionAction = exports.VmsOrderStatus = exports.VmsOrderSortByField = exports.VmsModType = exports.VmsImageType = exports.VmsImagePreset = exports.VmsDiscountType = exports.VmsDiscountStatus = exports.VmsDeliveryType = exports.VmsDealVendorSortableFields = exports.VmsDealType = exports.VmsDayOfTheWeek = exports.VmsChoicesSearchBy = exports.VmsAdjustmentFailureCodesV2 = exports.VisitorStatus = exports.VisitorRole = void 0;
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var Ac1AccessGroupKind;
(function (Ac1AccessGroupKind) {
    /** All accessGroups */
    Ac1AccessGroupKind["All"] = "ALL";
    /** Only accessGroups available for employees */
    Ac1AccessGroupKind["User"] = "USER";
    /** Only accessGroups available for visitors */
    Ac1AccessGroupKind["Visitor"] = "VISITOR";
})(Ac1AccessGroupKind = exports.Ac1AccessGroupKind || (exports.Ac1AccessGroupKind = {}));
var Ac1CredentialSetupCategory;
(function (Ac1CredentialSetupCategory) {
    /** Lisence plate readers to match cars to enter the parking */
    Ac1CredentialSetupCategory["LicensePlate"] = "license_plate";
    /** Physical card/mobs assigned to user */
    Ac1CredentialSetupCategory["Physical"] = "physical";
    /** QrCode or barcode? for access readers, mostly for guests or as backup for parkings */
    Ac1CredentialSetupCategory["QrCode"] = "qr_code";
    /** Category for example for HID Card */
    Ac1CredentialSetupCategory["Virtual"] = "virtual";
})(Ac1CredentialSetupCategory = exports.Ac1CredentialSetupCategory || (exports.Ac1CredentialSetupCategory = {}));
var Ac1IntegrationCredentialSetupOwnerTypes;
(function (Ac1IntegrationCredentialSetupOwnerTypes) {
    /** Defined credential setup for users */
    Ac1IntegrationCredentialSetupOwnerTypes["Employee"] = "employee";
    /** Defined credential setup for visitors */
    Ac1IntegrationCredentialSetupOwnerTypes["Visitor"] = "visitor";
})(Ac1IntegrationCredentialSetupOwnerTypes = exports.Ac1IntegrationCredentialSetupOwnerTypes || (exports.Ac1IntegrationCredentialSetupOwnerTypes = {}));
var Ac1QrCodeGenerator;
(function (Ac1QrCodeGenerator) {
    /** Random number below 1_000_000 */
    Ac1QrCodeGenerator["Basic"] = "basic";
    /** Currently 103 facility code and random number for single issue */
    Ac1QrCodeGenerator["Wiegand_24bit"] = "wiegand_24bit";
})(Ac1QrCodeGenerator = exports.Ac1QrCodeGenerator || (exports.Ac1QrCodeGenerator = {}));
var AccessControlSolution;
(function (AccessControlSolution) {
    AccessControlSolution["AccessOne"] = "ACCESS_ONE";
    AccessControlSolution["Vicinitee"] = "VICINITEE";
})(AccessControlSolution = exports.AccessControlSolution || (exports.AccessControlSolution = {}));
var AccessControlSystem;
(function (AccessControlSystem) {
    AccessControlSystem["Hid"] = "HID";
    AccessControlSystem["Vicinitee"] = "VICINITEE";
})(AccessControlSystem = exports.AccessControlSystem || (exports.AccessControlSystem = {}));
var AccessPassMethod;
(function (AccessPassMethod) {
    AccessPassMethod["Ble"] = "ble";
    AccessPassMethod["Nfc"] = "nfc";
    AccessPassMethod["Unknown"] = "unknown";
})(AccessPassMethod = exports.AccessPassMethod || (exports.AccessPassMethod = {}));
var AccessPassSystem;
(function (AccessPassSystem) {
    AccessPassSystem["Gallagher"] = "gallagher";
    AccessPassSystem["Hid"] = "hid";
    AccessPassSystem["Openpath"] = "openpath";
    AccessPassSystem["Swiftconnect"] = "swiftconnect";
    AccessPassSystem["Vicinitee"] = "vicinitee";
})(AccessPassSystem = exports.AccessPassSystem || (exports.AccessPassSystem = {}));
var ActivityAudience;
(function (ActivityAudience) {
    ActivityAudience["Everyone"] = "EVERYONE";
    ActivityAudience["Internal"] = "INTERNAL";
})(ActivityAudience = exports.ActivityAudience || (exports.ActivityAudience = {}));
var ActivityChangeFieldType;
(function (ActivityChangeFieldType) {
    ActivityChangeFieldType["BookableResource"] = "BOOKABLE_RESOURCE";
    ActivityChangeFieldType["BuildingLevel"] = "BUILDING_LEVEL";
    ActivityChangeFieldType["Date"] = "DATE";
    ActivityChangeFieldType["Document"] = "DOCUMENT";
    ActivityChangeFieldType["FlexTenant"] = "FLEX_TENANT";
    ActivityChangeFieldType["Integer"] = "INTEGER";
    ActivityChangeFieldType["Profile"] = "PROFILE";
    ActivityChangeFieldType["RequestAttachments"] = "REQUEST_ATTACHMENTS";
    ActivityChangeFieldType["RequestCategory"] = "REQUEST_CATEGORY";
    ActivityChangeFieldType["RequestPriority"] = "REQUEST_PRIORITY";
    ActivityChangeFieldType["RequestStatus"] = "REQUEST_STATUS";
    ActivityChangeFieldType["RequestSubcategory"] = "REQUEST_SUBCATEGORY";
    ActivityChangeFieldType["Space"] = "SPACE";
    ActivityChangeFieldType["String"] = "STRING";
})(ActivityChangeFieldType = exports.ActivityChangeFieldType || (exports.ActivityChangeFieldType = {}));
var ActivityRole;
(function (ActivityRole) {
    ActivityRole["Anon"] = "ANON";
    ActivityRole["Service"] = "SERVICE";
    ActivityRole["User"] = "USER";
})(ActivityRole = exports.ActivityRole || (exports.ActivityRole = {}));
var ActivitySortField;
(function (ActivitySortField) {
    ActivitySortField["Timestamp"] = "TIMESTAMP";
})(ActivitySortField = exports.ActivitySortField || (exports.ActivitySortField = {}));
var AdminAccessControlSolution;
(function (AdminAccessControlSolution) {
    AdminAccessControlSolution["AccessOne"] = "ACCESS_ONE";
    AdminAccessControlSolution["Vicinitee"] = "VICINITEE";
})(AdminAccessControlSolution = exports.AdminAccessControlSolution || (exports.AdminAccessControlSolution = {}));
var AdminAccessControlSystem;
(function (AdminAccessControlSystem) {
    AdminAccessControlSystem["Hid"] = "HID";
    AdminAccessControlSystem["Vicinitee"] = "VICINITEE";
})(AdminAccessControlSystem = exports.AdminAccessControlSystem || (exports.AdminAccessControlSystem = {}));
var AdminClientRegion;
(function (AdminClientRegion) {
    AdminClientRegion["Au"] = "AU";
    AdminClientRegion["Ca"] = "CA";
    AdminClientRegion["Eu"] = "EU";
    AdminClientRegion["Us"] = "US";
})(AdminClientRegion = exports.AdminClientRegion || (exports.AdminClientRegion = {}));
var AdminDestinationStatus;
(function (AdminDestinationStatus) {
    AdminDestinationStatus["Deactivated"] = "DEACTIVATED";
    AdminDestinationStatus["Hidden"] = "HIDDEN";
    AdminDestinationStatus["Live"] = "LIVE";
})(AdminDestinationStatus = exports.AdminDestinationStatus || (exports.AdminDestinationStatus = {}));
var AdminFeatureModuleType;
(function (AdminFeatureModuleType) {
    AdminFeatureModuleType["Bookings"] = "BOOKINGS";
    AdminFeatureModuleType["Requests"] = "REQUESTS";
    AdminFeatureModuleType["Visitors"] = "VISITORS";
})(AdminFeatureModuleType = exports.AdminFeatureModuleType || (exports.AdminFeatureModuleType = {}));
var AdminImageType;
(function (AdminImageType) {
    AdminImageType["Gif"] = "GIF";
    AdminImageType["Ico"] = "ICO";
    AdminImageType["Jpeg"] = "JPEG";
    AdminImageType["Png"] = "PNG";
})(AdminImageType = exports.AdminImageType || (exports.AdminImageType = {}));
var AdminParkingProvider;
(function (AdminParkingProvider) {
    AdminParkingProvider["None"] = "NONE";
    AdminParkingProvider["ParkOffice"] = "PARK_OFFICE";
    AdminParkingProvider["Ubipark"] = "UBIPARK";
})(AdminParkingProvider = exports.AdminParkingProvider || (exports.AdminParkingProvider = {}));
var AdminPlatformType;
(function (AdminPlatformType) {
    AdminPlatformType["Mobile"] = "MOBILE";
    AdminPlatformType["Web"] = "WEB";
})(AdminPlatformType = exports.AdminPlatformType || (exports.AdminPlatformType = {}));
var AdminProfileStatus;
(function (AdminProfileStatus) {
    AdminProfileStatus["Active"] = "ACTIVE";
    AdminProfileStatus["Deactivated"] = "DEACTIVATED";
    AdminProfileStatus["PendingApproval"] = "PENDING_APPROVAL";
})(AdminProfileStatus = exports.AdminProfileStatus || (exports.AdminProfileStatus = {}));
var AdminRegistrationType;
(function (AdminRegistrationType) {
    AdminRegistrationType["Commercial"] = "COMMERCIAL";
    AdminRegistrationType["Residential"] = "RESIDENTIAL";
    AdminRegistrationType["Visitor"] = "VISITOR";
})(AdminRegistrationType = exports.AdminRegistrationType || (exports.AdminRegistrationType = {}));
var AdminRole;
(function (AdminRole) {
    AdminRole["Authenticated"] = "AUTHENTICATED";
})(AdminRole = exports.AdminRole || (exports.AdminRole = {}));
var AdminSocialLinkType;
(function (AdminSocialLinkType) {
    AdminSocialLinkType["Email"] = "EMAIL";
    AdminSocialLinkType["Facebook"] = "FACEBOOK";
    AdminSocialLinkType["Instagram"] = "INSTAGRAM";
    AdminSocialLinkType["Linkedin"] = "LINKEDIN";
    AdminSocialLinkType["Other"] = "OTHER";
    AdminSocialLinkType["Phone"] = "PHONE";
    AdminSocialLinkType["Twitter"] = "TWITTER";
})(AdminSocialLinkType = exports.AdminSocialLinkType || (exports.AdminSocialLinkType = {}));
var AdminUiWidgetType;
(function (AdminUiWidgetType) {
    AdminUiWidgetType["Booking"] = "BOOKING";
    AdminUiWidgetType["Curated"] = "CURATED";
    AdminUiWidgetType["Discount"] = "DISCOUNT";
    AdminUiWidgetType["Events"] = "EVENTS";
    AdminUiWidgetType["Featured"] = "FEATURED";
    AdminUiWidgetType["Forme"] = "FORME";
    AdminUiWidgetType["News"] = "NEWS";
    AdminUiWidgetType["Popular"] = "POPULAR";
    AdminUiWidgetType["Quicklinks"] = "QUICKLINKS";
    AdminUiWidgetType["Reorder"] = "REORDER";
    AdminUiWidgetType["Transport"] = "TRANSPORT";
    AdminUiWidgetType["Trending"] = "TRENDING";
})(AdminUiWidgetType = exports.AdminUiWidgetType || (exports.AdminUiWidgetType = {}));
var AiRole;
(function (AiRole) {
    AiRole["Anon"] = "ANON";
    AiRole["Service"] = "SERVICE";
    AiRole["User"] = "USER";
})(AiRole = exports.AiRole || (exports.AiRole = {}));
var ApartmentSortField;
(function (ApartmentSortField) {
    ApartmentSortField["ApartmentName"] = "APARTMENT_NAME";
})(ApartmentSortField = exports.ApartmentSortField || (exports.ApartmentSortField = {}));
var AppleStoreStatus;
(function (AppleStoreStatus) {
    AppleStoreStatus["ApiNotAuthorized"] = "API_NOT_AUTHORIZED";
    AppleStoreStatus["InvalidBinary"] = "INVALID_BINARY";
    AppleStoreStatus["InReview"] = "IN_REVIEW";
    AppleStoreStatus["Live"] = "LIVE";
    AppleStoreStatus["MembershipExpired"] = "MEMBERSHIP_EXPIRED";
    AppleStoreStatus["MembershipExpires"] = "MEMBERSHIP_EXPIRES";
    AppleStoreStatus["MetadataRejected"] = "METADATA_REJECTED";
    AppleStoreStatus["PendingAgreement"] = "PENDING_AGREEMENT";
    AppleStoreStatus["PendingRelease"] = "PENDING_RELEASE";
    AppleStoreStatus["PrepareSubmission"] = "PREPARE_SUBMISSION";
    AppleStoreStatus["StoreRejected"] = "STORE_REJECTED";
    AppleStoreStatus["Unknown"] = "UNKNOWN";
    AppleStoreStatus["WaitingForReview"] = "WAITING_FOR_REVIEW";
})(AppleStoreStatus = exports.AppleStoreStatus || (exports.AppleStoreStatus = {}));
var AppointmentsViewScope;
(function (AppointmentsViewScope) {
    AppointmentsViewScope["All"] = "ALL";
    AppointmentsViewScope["My"] = "MY";
})(AppointmentsViewScope = exports.AppointmentsViewScope || (exports.AppointmentsViewScope = {}));
var ArticleApiRole;
(function (ArticleApiRole) {
    ArticleApiRole["Anon"] = "ANON";
    ArticleApiRole["Service"] = "SERVICE";
    ArticleApiRole["User"] = "USER";
})(ArticleApiRole = exports.ArticleApiRole || (exports.ArticleApiRole = {}));
var AssociationValidationRule;
(function (AssociationValidationRule) {
    AssociationValidationRule["Contains"] = "CONTAINS";
    AssociationValidationRule["ExactEmailDomain"] = "EXACT_EMAIL_DOMAIN";
    AssociationValidationRule["ExactMatch"] = "EXACT_MATCH";
})(AssociationValidationRule = exports.AssociationValidationRule || (exports.AssociationValidationRule = {}));
var AttendanceUpdate;
(function (AttendanceUpdate) {
    AttendanceUpdate["Attending"] = "ATTENDING";
    AttendanceUpdate["Cancel"] = "CANCEL";
})(AttendanceUpdate = exports.AttendanceUpdate || (exports.AttendanceUpdate = {}));
var AuthRole;
(function (AuthRole) {
    AuthRole["Service"] = "SERVICE";
    AuthRole["User"] = "USER";
})(AuthRole = exports.AuthRole || (exports.AuthRole = {}));
var AvatarImageType;
(function (AvatarImageType) {
    AvatarImageType["Gif"] = "GIF";
    AvatarImageType["Ico"] = "ICO";
    AvatarImageType["Jpeg"] = "JPEG";
    AvatarImageType["Png"] = "PNG";
})(AvatarImageType = exports.AvatarImageType || (exports.AvatarImageType = {}));
var BarcodeType;
(function (BarcodeType) {
    BarcodeType["Code128"] = "CODE128";
    BarcodeType["None"] = "None";
    BarcodeType["Qr"] = "QR";
})(BarcodeType = exports.BarcodeType || (exports.BarcodeType = {}));
var BillingCustomerType;
(function (BillingCustomerType) {
    BillingCustomerType["Company"] = "COMPANY";
    BillingCustomerType["FlexTenant"] = "FLEX_TENANT";
    BillingCustomerType["User"] = "USER";
})(BillingCustomerType = exports.BillingCustomerType || (exports.BillingCustomerType = {}));
var BookableResourceAddOnType;
(function (BookableResourceAddOnType) {
    BookableResourceAddOnType["FreeText"] = "FREE_TEXT";
    BookableResourceAddOnType["MultiOption"] = "MULTI_OPTION";
    BookableResourceAddOnType["SingleChoice"] = "SINGLE_CHOICE";
    BookableResourceAddOnType["SingleOption"] = "SINGLE_OPTION";
})(BookableResourceAddOnType = exports.BookableResourceAddOnType || (exports.BookableResourceAddOnType = {}));
var BookableResourceAvailabilityType;
(function (BookableResourceAvailabilityType) {
    BookableResourceAvailabilityType["Flexible"] = "FLEXIBLE";
    BookableResourceAvailabilityType["Slots"] = "SLOTS";
})(BookableResourceAvailabilityType = exports.BookableResourceAvailabilityType || (exports.BookableResourceAvailabilityType = {}));
var BookableResourceBookingApprovalType;
(function (BookableResourceBookingApprovalType) {
    BookableResourceBookingApprovalType["AutoForAll"] = "AutoForAll";
    BookableResourceBookingApprovalType["ManualForAll"] = "ManualForAll";
    BookableResourceBookingApprovalType["ManualForCompanies"] = "ManualForCompanies";
})(BookableResourceBookingApprovalType = exports.BookableResourceBookingApprovalType || (exports.BookableResourceBookingApprovalType = {}));
var BookableResourceCancellationRateType;
(function (BookableResourceCancellationRateType) {
    BookableResourceCancellationRateType["FixedRate"] = "FIXED_RATE";
    BookableResourceCancellationRateType["Percentage"] = "PERCENTAGE";
})(BookableResourceCancellationRateType = exports.BookableResourceCancellationRateType || (exports.BookableResourceCancellationRateType = {}));
var BookableResourceFeatureType;
(function (BookableResourceFeatureType) {
    BookableResourceFeatureType["RoomFeatures"] = "ROOM_FEATURES";
    BookableResourceFeatureType["SharedFacilities"] = "SHARED_FACILITIES";
})(BookableResourceFeatureType = exports.BookableResourceFeatureType || (exports.BookableResourceFeatureType = {}));
var BookableResourcePaymentMethod;
(function (BookableResourcePaymentMethod) {
    BookableResourcePaymentMethod["CreditCard"] = "CreditCard";
    BookableResourcePaymentMethod["Credits"] = "Credits";
    BookableResourcePaymentMethod["Invoice"] = "Invoice";
})(BookableResourcePaymentMethod = exports.BookableResourcePaymentMethod || (exports.BookableResourcePaymentMethod = {}));
var BookableResourceStatus;
(function (BookableResourceStatus) {
    BookableResourceStatus["Deleted"] = "DELETED";
    BookableResourceStatus["Draft"] = "DRAFT";
    BookableResourceStatus["PendingDeletion"] = "PENDING_DELETION";
    BookableResourceStatus["Published"] = "PUBLISHED";
})(BookableResourceStatus = exports.BookableResourceStatus || (exports.BookableResourceStatus = {}));
var BookingAccessControlCodeStatus;
(function (BookingAccessControlCodeStatus) {
    BookingAccessControlCodeStatus["Pending"] = "Pending";
    BookingAccessControlCodeStatus["SentToBarrierControl"] = "SentToBarrierControl";
})(BookingAccessControlCodeStatus = exports.BookingAccessControlCodeStatus || (exports.BookingAccessControlCodeStatus = {}));
var BookingAccessControlHistoryEventType;
(function (BookingAccessControlHistoryEventType) {
    BookingAccessControlHistoryEventType["BarrierArrive"] = "BarrierArrive";
    BookingAccessControlHistoryEventType["BarrierLeave"] = "BarrierLeave";
    BookingAccessControlHistoryEventType["CodeCreated"] = "CodeCreated";
    BookingAccessControlHistoryEventType["CodeDeleteFailed"] = "CodeDeleteFailed";
    BookingAccessControlHistoryEventType["CodeDeleted"] = "CodeDeleted";
    BookingAccessControlHistoryEventType["CodeSendFailed"] = "CodeSendFailed";
    BookingAccessControlHistoryEventType["CodeSent"] = "CodeSent";
})(BookingAccessControlHistoryEventType = exports.BookingAccessControlHistoryEventType || (exports.BookingAccessControlHistoryEventType = {}));
var BookingApprovalStatus;
(function (BookingApprovalStatus) {
    BookingApprovalStatus["Approved"] = "APPROVED";
    BookingApprovalStatus["Declined"] = "DECLINED";
    BookingApprovalStatus["Pending"] = "PENDING";
    BookingApprovalStatus["PendingWorkplaceManagerApproval"] = "PENDING_WORKPLACE_MANAGER_APPROVAL";
})(BookingApprovalStatus = exports.BookingApprovalStatus || (exports.BookingApprovalStatus = {}));
var BookingDiscountStatus;
(function (BookingDiscountStatus) {
    BookingDiscountStatus["Deleted"] = "Deleted";
    BookingDiscountStatus["Expired"] = "Expired";
    BookingDiscountStatus["Live"] = "Live";
    BookingDiscountStatus["Upcoming"] = "Upcoming";
})(BookingDiscountStatus = exports.BookingDiscountStatus || (exports.BookingDiscountStatus = {}));
var BookingDiscountType;
(function (BookingDiscountType) {
    BookingDiscountType["EarlyBooking"] = "EARLY_BOOKING";
    BookingDiscountType["Periodic"] = "PERIODIC";
})(BookingDiscountType = exports.BookingDiscountType || (exports.BookingDiscountType = {}));
var BookingInvoiceContactTypeInput;
(function (BookingInvoiceContactTypeInput) {
    BookingInvoiceContactTypeInput["BillingCustomer"] = "BILLING_CUSTOMER";
    BookingInvoiceContactTypeInput["ExistingContact"] = "EXISTING_CONTACT";
    BookingInvoiceContactTypeInput["NewContact"] = "NEW_CONTACT";
    BookingInvoiceContactTypeInput["Self"] = "SELF";
})(BookingInvoiceContactTypeInput = exports.BookingInvoiceContactTypeInput || (exports.BookingInvoiceContactTypeInput = {}));
var BookingPaymentStatus;
(function (BookingPaymentStatus) {
    BookingPaymentStatus["Failed"] = "FAILED";
    BookingPaymentStatus["Paid"] = "PAID";
    BookingPaymentStatus["Pending"] = "PENDING";
    BookingPaymentStatus["Refunded"] = "REFUNDED";
    BookingPaymentStatus["RefundFailed"] = "REFUND_FAILED";
})(BookingPaymentStatus = exports.BookingPaymentStatus || (exports.BookingPaymentStatus = {}));
var BookingSortOrder;
(function (BookingSortOrder) {
    BookingSortOrder["StartdateAscending"] = "STARTDATE_ASCENDING";
    BookingSortOrder["StartdateDescending"] = "STARTDATE_DESCENDING";
})(BookingSortOrder = exports.BookingSortOrder || (exports.BookingSortOrder = {}));
var BookingStatus;
(function (BookingStatus) {
    BookingStatus["Approved"] = "APPROVED";
    BookingStatus["Cancelled"] = "CANCELLED";
    BookingStatus["Declined"] = "DECLINED";
    BookingStatus["PaymentFailed"] = "PAYMENT_FAILED";
    BookingStatus["PendingApproval"] = "PENDING_APPROVAL";
    BookingStatus["PendingPayment"] = "PENDING_PAYMENT";
    BookingStatus["PendingWorkplaceManagerApproval"] = "PENDING_WORKPLACE_MANAGER_APPROVAL";
})(BookingStatus = exports.BookingStatus || (exports.BookingStatus = {}));
var BookingsRole;
(function (BookingsRole) {
    BookingsRole["AuthenticatedNoPermission"] = "AUTHENTICATED_NO_PERMISSION";
    BookingsRole["Service"] = "SERVICE";
})(BookingsRole = exports.BookingsRole || (exports.BookingsRole = {}));
var BpAppointmentSortField;
(function (BpAppointmentSortField) {
    BpAppointmentSortField["End"] = "end";
    BpAppointmentSortField["Organiser"] = "organiser";
    BpAppointmentSortField["Start"] = "start";
    BpAppointmentSortField["Status"] = "status";
    BpAppointmentSortField["Subject"] = "subject";
})(BpAppointmentSortField = exports.BpAppointmentSortField || (exports.BpAppointmentSortField = {}));
var BpVisitorSortField;
(function (BpVisitorSortField) {
    BpVisitorSortField["Email"] = "email";
    BpVisitorSortField["Firstname"] = "firstname";
    BpVisitorSortField["Lastname"] = "lastname";
})(BpVisitorSortField = exports.BpVisitorSortField || (exports.BpVisitorSortField = {}));
var CmsArticleStatus;
(function (CmsArticleStatus) {
    CmsArticleStatus["Archived"] = "ARCHIVED";
    CmsArticleStatus["Draft"] = "DRAFT";
    CmsArticleStatus["Published"] = "PUBLISHED";
    CmsArticleStatus["UnpublishedChanges"] = "UNPUBLISHED_CHANGES";
})(CmsArticleStatus = exports.CmsArticleStatus || (exports.CmsArticleStatus = {}));
var CacheControlScope;
(function (CacheControlScope) {
    CacheControlScope["Private"] = "PRIVATE";
    CacheControlScope["Public"] = "PUBLIC";
})(CacheControlScope = exports.CacheControlScope || (exports.CacheControlScope = {}));
var CancellingUserRole;
(function (CancellingUserRole) {
    CancellingUserRole["Host"] = "HOST";
    CancellingUserRole["System"] = "SYSTEM";
    CancellingUserRole["User"] = "USER";
})(CancellingUserRole = exports.CancellingUserRole || (exports.CancellingUserRole = {}));
var CardBrand;
(function (CardBrand) {
    CardBrand["AmericanExpress"] = "AMERICAN_EXPRESS";
    CardBrand["DinersClub"] = "DINERS_CLUB";
    CardBrand["Discover"] = "DISCOVER";
    CardBrand["Jcb"] = "JCB";
    CardBrand["Mastercard"] = "MASTERCARD";
    CardBrand["Unionpay"] = "UNIONPAY";
    CardBrand["Unknown"] = "UNKNOWN";
    CardBrand["Visa"] = "VISA";
})(CardBrand = exports.CardBrand || (exports.CardBrand = {}));
var ChangePasswordErrorCode;
(function (ChangePasswordErrorCode) {
    ChangePasswordErrorCode["PasswordMinLength"] = "PASSWORD_MIN_LENGTH";
    ChangePasswordErrorCode["PasswordMustContainLetters"] = "PASSWORD_MUST_CONTAIN_LETTERS";
    ChangePasswordErrorCode["PasswordMustContainNumbers"] = "PASSWORD_MUST_CONTAIN_NUMBERS";
    ChangePasswordErrorCode["TokenExpired"] = "TOKEN_EXPIRED";
    ChangePasswordErrorCode["TokenNotFound"] = "TOKEN_NOT_FOUND";
    ChangePasswordErrorCode["Unknown"] = "UNKNOWN";
})(ChangePasswordErrorCode = exports.ChangePasswordErrorCode || (exports.ChangePasswordErrorCode = {}));
/**
 * Enumeration of all the possible failure codes during checkout.
 * This type is a concatenation of PaymentFailureCodes and checkout
 * specific failures.
 */
var CheckoutFailureCodes;
(function (CheckoutFailureCodes) {
    CheckoutFailureCodes["AmountTooLarge"] = "AMOUNT_TOO_LARGE";
    CheckoutFailureCodes["AmountTooSmall"] = "AMOUNT_TOO_SMALL";
    CheckoutFailureCodes["BalanceInsufficient"] = "BALANCE_INSUFFICIENT";
    CheckoutFailureCodes["CardDeclined"] = "CARD_DECLINED";
    CheckoutFailureCodes["DeliveryMethodInactive"] = "DELIVERY_METHOD_INACTIVE";
    CheckoutFailureCodes["DeliveryNotAvailable"] = "DELIVERY_NOT_AVAILABLE";
    CheckoutFailureCodes["DeliveryTimeOutOfRange"] = "DELIVERY_TIME_OUT_OF_RANGE";
    CheckoutFailureCodes["ExpiredCard"] = "EXPIRED_CARD";
    CheckoutFailureCodes["MultipleSubscriptionProducts"] = "MULTIPLE_SUBSCRIPTION_PRODUCTS";
    CheckoutFailureCodes["OrderHasSubscriptionAndOtherProducts"] = "ORDER_HAS_SUBSCRIPTION_AND_OTHER_PRODUCTS";
    CheckoutFailureCodes["OrderMinimumNotExceeded"] = "ORDER_MINIMUM_NOT_EXCEEDED";
    CheckoutFailureCodes["Other"] = "OTHER";
    CheckoutFailureCodes["ProductHidden"] = "PRODUCT_HIDDEN";
    CheckoutFailureCodes["ProductOutOfStock"] = "PRODUCT_OUT_OF_STOCK";
    CheckoutFailureCodes["ProductTimeOutOfRange"] = "PRODUCT_TIME_OUT_OF_RANGE";
    CheckoutFailureCodes["SiteNotEnabled"] = "SITE_NOT_ENABLED";
    CheckoutFailureCodes["SiteNotOpen"] = "SITE_NOT_OPEN";
    CheckoutFailureCodes["StripeRequestInput"] = "STRIPE_REQUEST_INPUT";
    CheckoutFailureCodes["VendorClosed"] = "VENDOR_CLOSED";
    CheckoutFailureCodes["VendorHidden"] = "VENDOR_HIDDEN";
    CheckoutFailureCodes["VendorTncNotAccepted"] = "VENDOR_TNC_NOT_ACCEPTED";
})(CheckoutFailureCodes = exports.CheckoutFailureCodes || (exports.CheckoutFailureCodes = {}));
/**
 * Enumeration of all the possible failure codes during checkout.
 * This type is a concatenation of PaymentFailureCodes and checkout
 * specific failures.
 */
var CheckoutFailureCodesV2;
(function (CheckoutFailureCodesV2) {
    CheckoutFailureCodesV2["AmountTooLarge"] = "AMOUNT_TOO_LARGE";
    CheckoutFailureCodesV2["AmountTooSmall"] = "AMOUNT_TOO_SMALL";
    CheckoutFailureCodesV2["AuthenticationRequired"] = "AUTHENTICATION_REQUIRED";
    CheckoutFailureCodesV2["BalanceInsufficient"] = "BALANCE_INSUFFICIENT";
    CheckoutFailureCodesV2["CardDeclined"] = "CARD_DECLINED";
    CheckoutFailureCodesV2["DeliveryMethodInactive"] = "DELIVERY_METHOD_INACTIVE";
    CheckoutFailureCodesV2["DeliveryNotAvailable"] = "DELIVERY_NOT_AVAILABLE";
    CheckoutFailureCodesV2["DeliveryTimeOutOfRange"] = "DELIVERY_TIME_OUT_OF_RANGE";
    CheckoutFailureCodesV2["ExpiredCard"] = "EXPIRED_CARD";
    CheckoutFailureCodesV2["MultipleSubscriptionProducts"] = "MULTIPLE_SUBSCRIPTION_PRODUCTS";
    CheckoutFailureCodesV2["OrderHasSubscriptionAndOtherProducts"] = "ORDER_HAS_SUBSCRIPTION_AND_OTHER_PRODUCTS";
    CheckoutFailureCodesV2["OrderMinimumNotExceeded"] = "ORDER_MINIMUM_NOT_EXCEEDED";
    CheckoutFailureCodesV2["Other"] = "OTHER";
    CheckoutFailureCodesV2["ProductHidden"] = "PRODUCT_HIDDEN";
    CheckoutFailureCodesV2["ProductOutOfStock"] = "PRODUCT_OUT_OF_STOCK";
    CheckoutFailureCodesV2["ProductTimeOutOfRange"] = "PRODUCT_TIME_OUT_OF_RANGE";
    CheckoutFailureCodesV2["SiteNotEnabled"] = "SITE_NOT_ENABLED";
    CheckoutFailureCodesV2["SiteNotOpen"] = "SITE_NOT_OPEN";
    CheckoutFailureCodesV2["StripeRequestInput"] = "STRIPE_REQUEST_INPUT";
    CheckoutFailureCodesV2["VendorClosed"] = "VENDOR_CLOSED";
    CheckoutFailureCodesV2["VendorHidden"] = "VENDOR_HIDDEN";
    CheckoutFailureCodesV2["VendorTncNotAccepted"] = "VENDOR_TNC_NOT_ACCEPTED";
})(CheckoutFailureCodesV2 = exports.CheckoutFailureCodesV2 || (exports.CheckoutFailureCodesV2 = {}));
var ChoicesSearchBy;
(function (ChoicesSearchBy) {
    ChoicesSearchBy["Name"] = "NAME";
})(ChoicesSearchBy = exports.ChoicesSearchBy || (exports.ChoicesSearchBy = {}));
var ClientRegion;
(function (ClientRegion) {
    ClientRegion["Au"] = "AU";
    ClientRegion["Ca"] = "CA";
    ClientRegion["Eu"] = "EU";
    ClientRegion["Us"] = "US";
})(ClientRegion = exports.ClientRegion || (exports.ClientRegion = {}));
var CollectionContentType;
(function (CollectionContentType) {
    CollectionContentType["BookableProduct"] = "BOOKABLE_PRODUCT";
    CollectionContentType["BuildingInfoPost"] = "BUILDING_INFO_POST";
    CollectionContentType["DealProduct"] = "DEAL_PRODUCT";
    CollectionContentType["DealVendor"] = "DEAL_VENDOR";
    CollectionContentType["EventPost"] = "EVENT_POST";
    CollectionContentType["NewsPost"] = "NEWS_POST";
    CollectionContentType["PlainProduct"] = "PLAIN_PRODUCT";
    CollectionContentType["SubscriptionProduct"] = "SUBSCRIPTION_PRODUCT";
    CollectionContentType["Vendor"] = "VENDOR";
})(CollectionContentType = exports.CollectionContentType || (exports.CollectionContentType = {}));
var CommentOperationType;
(function (CommentOperationType) {
    CommentOperationType["Comment"] = "COMMENT";
    CommentOperationType["RemoveComment"] = "REMOVE_COMMENT";
})(CommentOperationType = exports.CommentOperationType || (exports.CommentOperationType = {}));
var CompanyV2SortField;
(function (CompanyV2SortField) {
    CompanyV2SortField["CompanyName"] = "COMPANY_NAME";
    CompanyV2SortField["Industry"] = "INDUSTRY";
    CompanyV2SortField["SiteCount"] = "SITE_COUNT";
})(CompanyV2SortField = exports.CompanyV2SortField || (exports.CompanyV2SortField = {}));
var ContentFeaturedLevel;
(function (ContentFeaturedLevel) {
    ContentFeaturedLevel["Combined"] = "COMBINED";
    ContentFeaturedLevel["Featured"] = "FEATURED";
    ContentFeaturedLevel["NonFeatured"] = "NON_FEATURED";
})(ContentFeaturedLevel = exports.ContentFeaturedLevel || (exports.ContentFeaturedLevel = {}));
var ContentInteractionType;
(function (ContentInteractionType) {
    ContentInteractionType["Comment"] = "Comment";
    ContentInteractionType["Like"] = "Like";
    ContentInteractionType["RemoveComment"] = "RemoveComment";
    ContentInteractionType["RemoveLike"] = "RemoveLike";
    ContentInteractionType["RemoveRsvp"] = "RemoveRsvp";
    ContentInteractionType["Rsvp"] = "Rsvp";
    ContentInteractionType["View"] = "View";
})(ContentInteractionType = exports.ContentInteractionType || (exports.ContentInteractionType = {}));
var ContentRestrictionLevel;
(function (ContentRestrictionLevel) {
    ContentRestrictionLevel["Combined"] = "COMBINED";
    ContentRestrictionLevel["NonRestricted"] = "NON_RESTRICTED";
    ContentRestrictionLevel["Restricted"] = "RESTRICTED";
})(ContentRestrictionLevel = exports.ContentRestrictionLevel || (exports.ContentRestrictionLevel = {}));
var ContentSortType;
(function (ContentSortType) {
    ContentSortType["DistanceFromNow"] = "DISTANCE_FROM_NOW";
    ContentSortType["Relevance"] = "RELEVANCE";
})(ContentSortType = exports.ContentSortType || (exports.ContentSortType = {}));
var ContentType;
(function (ContentType) {
    ContentType["CommunityPost"] = "COMMUNITY_POST";
    ContentType["EventPost"] = "EVENT_POST";
    ContentType["NewsPost"] = "NEWS_POST";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var CortexEnricherContentType;
(function (CortexEnricherContentType) {
    CortexEnricherContentType["Event"] = "EVENT";
    CortexEnricherContentType["Session"] = "SESSION";
})(CortexEnricherContentType = exports.CortexEnricherContentType || (exports.CortexEnricherContentType = {}));
var CortexEnricherProfileRegistrationType;
(function (CortexEnricherProfileRegistrationType) {
    CortexEnricherProfileRegistrationType["Commercial"] = "COMMERCIAL";
    CortexEnricherProfileRegistrationType["Residential"] = "RESIDENTIAL";
    CortexEnricherProfileRegistrationType["Visitor"] = "VISITOR";
})(CortexEnricherProfileRegistrationType = exports.CortexEnricherProfileRegistrationType || (exports.CortexEnricherProfileRegistrationType = {}));
var CortexEnricherRole;
(function (CortexEnricherRole) {
    CortexEnricherRole["Authenticated"] = "AUTHENTICATED";
    CortexEnricherRole["Service"] = "SERVICE";
})(CortexEnricherRole = exports.CortexEnricherRole || (exports.CortexEnricherRole = {}));
var CreditAccountType;
(function (CreditAccountType) {
    CreditAccountType["RecurringWithPurchase"] = "RECURRING_WITH_PURCHASE";
})(CreditAccountType = exports.CreditAccountType || (exports.CreditAccountType = {}));
var CreditCustomerType;
(function (CreditCustomerType) {
    CreditCustomerType["FlexTenant"] = "FLEX_TENANT";
    CreditCustomerType["User"] = "USER";
})(CreditCustomerType = exports.CreditCustomerType || (exports.CreditCustomerType = {}));
var CreditProviderType;
(function (CreditProviderType) {
    CreditProviderType["FlexOperator"] = "FLEX_OPERATOR";
})(CreditProviderType = exports.CreditProviderType || (exports.CreditProviderType = {}));
var CreditRole;
(function (CreditRole) {
    CreditRole["Anon"] = "ANON";
    CreditRole["PropertyManager"] = "PROPERTY_MANAGER";
    CreditRole["Service"] = "SERVICE";
    CreditRole["User"] = "USER";
    CreditRole["WorkplaceManager"] = "WORKPLACE_MANAGER";
})(CreditRole = exports.CreditRole || (exports.CreditRole = {}));
var CreditStatsQueryRole;
(function (CreditStatsQueryRole) {
    CreditStatsQueryRole["FlexManager"] = "FLEX_MANAGER";
    CreditStatsQueryRole["WorkplaceManager"] = "WORKPLACE_MANAGER";
})(CreditStatsQueryRole = exports.CreditStatsQueryRole || (exports.CreditStatsQueryRole = {}));
var CreditSubAccountType;
(function (CreditSubAccountType) {
    CreditSubAccountType["MonthlyRecurring"] = "MONTHLY_RECURRING";
    CreditSubAccountType["Purchased"] = "PURCHASED";
})(CreditSubAccountType = exports.CreditSubAccountType || (exports.CreditSubAccountType = {}));
var CreditTransactionType;
(function (CreditTransactionType) {
    CreditTransactionType["Adjustment"] = "ADJUSTMENT";
    CreditTransactionType["Charge"] = "CHARGE";
    CreditTransactionType["Purchase"] = "PURCHASE";
    CreditTransactionType["Refund"] = "REFUND";
})(CreditTransactionType = exports.CreditTransactionType || (exports.CreditTransactionType = {}));
var CreditTransactionsQueryRole;
(function (CreditTransactionsQueryRole) {
    CreditTransactionsQueryRole["FlexManager"] = "FLEX_MANAGER";
    CreditTransactionsQueryRole["WorkplaceManager"] = "WORKPLACE_MANAGER";
})(CreditTransactionsQueryRole = exports.CreditTransactionsQueryRole || (exports.CreditTransactionsQueryRole = {}));
var DataType;
(function (DataType) {
    DataType["Count"] = "COUNT";
    DataType["Currency"] = "CURRENCY";
    DataType["Number"] = "NUMBER";
    DataType["Timespan"] = "TIMESPAN";
})(DataType = exports.DataType || (exports.DataType = {}));
var DateFilterOperatorV3;
(function (DateFilterOperatorV3) {
    DateFilterOperatorV3["Gte"] = "GTE";
    DateFilterOperatorV3["Lte"] = "LTE";
})(DateFilterOperatorV3 = exports.DateFilterOperatorV3 || (exports.DateFilterOperatorV3 = {}));
/** Day of the week for opening hours */
var DayOfTheWeek;
(function (DayOfTheWeek) {
    DayOfTheWeek["Friday"] = "FRIDAY";
    DayOfTheWeek["Monday"] = "MONDAY";
    DayOfTheWeek["Saturday"] = "SATURDAY";
    DayOfTheWeek["Sunday"] = "SUNDAY";
    DayOfTheWeek["Thursday"] = "THURSDAY";
    DayOfTheWeek["Tuesday"] = "TUESDAY";
    DayOfTheWeek["Wednesday"] = "WEDNESDAY";
})(DayOfTheWeek = exports.DayOfTheWeek || (exports.DayOfTheWeek = {}));
var DealType;
(function (DealType) {
    DealType["AffiliateLink"] = "AFFILIATE_LINK";
    DealType["NonRedeemable"] = "NON_REDEEMABLE";
    DealType["Redeemable"] = "REDEEMABLE";
})(DealType = exports.DealType || (exports.DealType = {}));
var DealVendorSortableFields;
(function (DealVendorSortableFields) {
    DealVendorSortableFields["Name"] = "NAME";
    DealVendorSortableFields["Sites"] = "SITES";
    DealVendorSortableFields["Status"] = "STATUS";
})(DealVendorSortableFields = exports.DealVendorSortableFields || (exports.DealVendorSortableFields = {}));
var DeliveryType;
(function (DeliveryType) {
    DeliveryType["Delivery"] = "DELIVERY";
    DeliveryType["Pickup"] = "PICKUP";
})(DeliveryType = exports.DeliveryType || (exports.DeliveryType = {}));
var DestinationAppId;
(function (DestinationAppId) {
    DestinationAppId["Account"] = "account";
    DestinationAppId["Web"] = "web";
})(DestinationAppId = exports.DestinationAppId || (exports.DestinationAppId = {}));
var DestinationStatus;
(function (DestinationStatus) {
    DestinationStatus["Deactivated"] = "DEACTIVATED";
    DestinationStatus["Hidden"] = "HIDDEN";
    DestinationStatus["Live"] = "LIVE";
})(DestinationStatus = exports.DestinationStatus || (exports.DestinationStatus = {}));
var DestinationTierLevel;
(function (DestinationTierLevel) {
    DestinationTierLevel["Essentials"] = "Essentials";
    DestinationTierLevel["Unlimited"] = "Unlimited";
})(DestinationTierLevel = exports.DestinationTierLevel || (exports.DestinationTierLevel = {}));
var DestinationType;
(function (DestinationType) {
    DestinationType["AuthApi"] = "AUTH_API";
    DestinationType["EquiemOne"] = "EQUIEM_ONE";
    DestinationType["Iris"] = "IRIS";
    DestinationType["Portal"] = "PORTAL";
    DestinationType["Unknown"] = "UNKNOWN";
    DestinationType["Vms"] = "VMS";
})(DestinationType = exports.DestinationType || (exports.DestinationType = {}));
var DiscountStatus;
(function (DiscountStatus) {
    DiscountStatus["Active"] = "ACTIVE";
    DiscountStatus["Completed"] = "COMPLETED";
    DiscountStatus["Inactive"] = "INACTIVE";
})(DiscountStatus = exports.DiscountStatus || (exports.DiscountStatus = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["Amount"] = "AMOUNT";
    DiscountType["Percentage"] = "PERCENTAGE";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
/** Current status of a DNS check. */
var DnsCheckStatus;
(function (DnsCheckStatus) {
    /** The client has created this entry yet, but there is pending actions on Equiem's side to provision it. */
    DnsCheckStatus["Created"] = "CREATED";
    /** This entry was deprovisioned as it became inactive on the client side. */
    DnsCheckStatus["Deprovisioned"] = "DEPROVISIONED";
    /** The client has not created this entry yet. */
    DnsCheckStatus["NotCreated"] = "NOT_CREATED";
    /** This entry is currently active and fully provisioned. */
    DnsCheckStatus["Provisioned"] = "PROVISIONED";
})(DnsCheckStatus = exports.DnsCheckStatus || (exports.DnsCheckStatus = {}));
var DnsRecordType;
(function (DnsRecordType) {
    DnsRecordType["A"] = "A";
    DnsRecordType["Aaaa"] = "AAAA";
    DnsRecordType["Aname"] = "ANAME";
    DnsRecordType["Cname"] = "CNAME";
    DnsRecordType["Mx"] = "MX";
    DnsRecordType["Txt"] = "TXT";
})(DnsRecordType = exports.DnsRecordType || (exports.DnsRecordType = {}));
var DocumentContentDisposition;
(function (DocumentContentDisposition) {
    DocumentContentDisposition["Attachment"] = "ATTACHMENT";
    DocumentContentDisposition["Inline"] = "INLINE";
})(DocumentContentDisposition = exports.DocumentContentDisposition || (exports.DocumentContentDisposition = {}));
var DocumentRole;
(function (DocumentRole) {
    DocumentRole["Anon"] = "ANON";
    DocumentRole["Service"] = "SERVICE";
    DocumentRole["User"] = "USER";
})(DocumentRole = exports.DocumentRole || (exports.DocumentRole = {}));
var DocumentRootPrefixType;
(function (DocumentRootPrefixType) {
    DocumentRootPrefixType["Building"] = "BUILDING";
    DocumentRootPrefixType["Portfolio"] = "PORTFOLIO";
    DocumentRootPrefixType["Site"] = "SITE";
})(DocumentRootPrefixType = exports.DocumentRootPrefixType || (exports.DocumentRootPrefixType = {}));
var DomainServiceRole;
(function (DomainServiceRole) {
    DomainServiceRole["Anon"] = "ANON";
    DomainServiceRole["Service"] = "SERVICE";
})(DomainServiceRole = exports.DomainServiceRole || (exports.DomainServiceRole = {}));
var EmailStatus;
(function (EmailStatus) {
    EmailStatus["Exists"] = "EXISTS";
    EmailStatus["ExistsOnDestination"] = "EXISTS_ON_DESTINATION";
    EmailStatus["NotAllowed"] = "NOT_ALLOWED";
    EmailStatus["Unregistered"] = "UNREGISTERED";
})(EmailStatus = exports.EmailStatus || (exports.EmailStatus = {}));
var EquiemOneWidgetId;
(function (EquiemOneWidgetId) {
    EquiemOneWidgetId["Welcome"] = "Welcome";
})(EquiemOneWidgetId = exports.EquiemOneWidgetId || (exports.EquiemOneWidgetId = {}));
var EventCheckInFailureReason;
(function (EventCheckInFailureReason) {
    EventCheckInFailureReason["AcceptTandcRequired"] = "ACCEPT_TANDC_REQUIRED";
    EventCheckInFailureReason["AlreadyCheckedIn"] = "ALREADY_CHECKED_IN";
    EventCheckInFailureReason["EventFull"] = "EVENT_FULL";
    EventCheckInFailureReason["MultipleUsersFound"] = "MULTIPLE_USERS_FOUND";
    EventCheckInFailureReason["OccurrenceNotFound"] = "OCCURRENCE_NOT_FOUND";
    EventCheckInFailureReason["SessionPurchaseRequired"] = "SESSION_PURCHASE_REQUIRED";
    EventCheckInFailureReason["UserNotFound"] = "USER_NOT_FOUND";
})(EventCheckInFailureReason = exports.EventCheckInFailureReason || (exports.EventCheckInFailureReason = {}));
var FeatureModuleType;
(function (FeatureModuleType) {
    FeatureModuleType["Bookings"] = "BOOKINGS";
    FeatureModuleType["Requests"] = "REQUESTS";
    FeatureModuleType["Visitors"] = "VISITORS";
})(FeatureModuleType = exports.FeatureModuleType || (exports.FeatureModuleType = {}));
var FeatureModulesFilterValue;
(function (FeatureModulesFilterValue) {
    FeatureModulesFilterValue["Ignore"] = "IGNORE";
    FeatureModulesFilterValue["No"] = "NO";
    FeatureModulesFilterValue["Yes"] = "YES";
})(FeatureModulesFilterValue = exports.FeatureModulesFilterValue || (exports.FeatureModulesFilterValue = {}));
var FeedbackFormat;
(function (FeedbackFormat) {
    FeedbackFormat["Face"] = "FACE";
    FeedbackFormat["Nps"] = "NPS";
})(FeedbackFormat = exports.FeedbackFormat || (exports.FeedbackFormat = {}));
var FeedbackMetricTargetType;
(function (FeedbackMetricTargetType) {
    FeedbackMetricTargetType["Face"] = "FACE";
    FeedbackMetricTargetType["Nps"] = "NPS";
})(FeedbackMetricTargetType = exports.FeedbackMetricTargetType || (exports.FeedbackMetricTargetType = {}));
var FlexTenantStatus;
(function (FlexTenantStatus) {
    FlexTenantStatus["Active"] = "Active";
    FlexTenantStatus["Expired"] = "Expired";
    FlexTenantStatus["NearingExpiry"] = "NearingExpiry";
    FlexTenantStatus["PreMoveIn"] = "PreMoveIn";
})(FlexTenantStatus = exports.FlexTenantStatus || (exports.FlexTenantStatus = {}));
var GoogleStoreStatus;
(function (GoogleStoreStatus) {
    GoogleStoreStatus["AccountNotVerified"] = "ACCOUNT_NOT_VERIFIED";
    GoogleStoreStatus["Live"] = "LIVE";
    GoogleStoreStatus["PendingRelease"] = "PENDING_RELEASE";
    GoogleStoreStatus["StoreRejected"] = "STORE_REJECTED";
    GoogleStoreStatus["WaitingForReview"] = "WAITING_FOR_REVIEW";
})(GoogleStoreStatus = exports.GoogleStoreStatus || (exports.GoogleStoreStatus = {}));
var ImagePreset;
(function (ImagePreset) {
    ImagePreset["Thumbnail"] = "THUMBNAIL";
})(ImagePreset = exports.ImagePreset || (exports.ImagePreset = {}));
var ImageType;
(function (ImageType) {
    ImageType["Gif"] = "GIF";
    ImageType["Jpeg"] = "JPEG";
    ImageType["Png"] = "PNG";
})(ImageType = exports.ImageType || (exports.ImageType = {}));
var InactivityUnit;
(function (InactivityUnit) {
    InactivityUnit["Days"] = "days";
    InactivityUnit["Months"] = "months";
    InactivityUnit["Weeks"] = "weeks";
})(InactivityUnit = exports.InactivityUnit || (exports.InactivityUnit = {}));
var InfrastructureGroupStatus;
(function (InfrastructureGroupStatus) {
    InfrastructureGroupStatus["Deployed"] = "DEPLOYED";
    InfrastructureGroupStatus["Deploying"] = "DEPLOYING";
    InfrastructureGroupStatus["Error"] = "ERROR";
    InfrastructureGroupStatus["Pending"] = "PENDING";
})(InfrastructureGroupStatus = exports.InfrastructureGroupStatus || (exports.InfrastructureGroupStatus = {}));
var InteractionsRole;
(function (InteractionsRole) {
    InteractionsRole["Anon"] = "ANON";
    InteractionsRole["Service"] = "SERVICE";
    InteractionsRole["User"] = "USER";
})(InteractionsRole = exports.InteractionsRole || (exports.InteractionsRole = {}));
var InviteHistoryAction;
(function (InviteHistoryAction) {
    InviteHistoryAction["InvitationResent"] = "InvitationResent";
    InviteHistoryAction["InvitationSent"] = "InvitationSent";
    InviteHistoryAction["UserRegistered"] = "UserRegistered";
    InviteHistoryAction["UserUnsubscribed"] = "UserUnsubscribed";
    InviteHistoryAction["ApprovePendingApproval"] = "approvePendingApproval";
})(InviteHistoryAction = exports.InviteHistoryAction || (exports.InviteHistoryAction = {}));
var InviteSortField;
(function (InviteSortField) {
    InviteSortField["Created"] = "CREATED";
    InviteSortField["Email"] = "EMAIL";
    InviteSortField["Name"] = "NAME";
    InviteSortField["Updated"] = "UPDATED";
})(InviteSortField = exports.InviteSortField || (exports.InviteSortField = {}));
var InviteStatus;
(function (InviteStatus) {
    InviteStatus["Expired"] = "EXPIRED";
    InviteStatus["Pending"] = "PENDING";
    InviteStatus["PendingApproval"] = "PENDING_APPROVAL";
    InviteStatus["Registered"] = "REGISTERED";
})(InviteStatus = exports.InviteStatus || (exports.InviteStatus = {}));
var LikeOperationType;
(function (LikeOperationType) {
    LikeOperationType["Like"] = "LIKE";
    LikeOperationType["RemoveLike"] = "REMOVE_LIKE";
})(LikeOperationType = exports.LikeOperationType || (exports.LikeOperationType = {}));
var LinkTrackType;
(function (LinkTrackType) {
    LinkTrackType["Quicklink"] = "QUICKLINK";
})(LinkTrackType = exports.LinkTrackType || (exports.LinkTrackType = {}));
var MetricUnit;
(function (MetricUnit) {
    MetricUnit["Count"] = "Count";
    MetricUnit["Percentage"] = "Percentage";
})(MetricUnit = exports.MetricUnit || (exports.MetricUnit = {}));
var ModType;
(function (ModType) {
    ModType["FreeText"] = "FREE_TEXT";
    ModType["MultiChoice"] = "MULTI_CHOICE";
    ModType["SingleChoice"] = "SINGLE_CHOICE";
})(ModType = exports.ModType || (exports.ModType = {}));
var MySpacesQueryRole;
(function (MySpacesQueryRole) {
    MySpacesQueryRole["RequestManager"] = "REQUEST_MANAGER";
})(MySpacesQueryRole = exports.MySpacesQueryRole || (exports.MySpacesQueryRole = {}));
var OccurrenceType;
(function (OccurrenceType) {
    OccurrenceType["Event"] = "EVENT";
    OccurrenceType["Session"] = "SESSION";
})(OccurrenceType = exports.OccurrenceType || (exports.OccurrenceType = {}));
var OnSiteStatus;
(function (OnSiteStatus) {
    OnSiteStatus["Off"] = "OFF";
    OnSiteStatus["On"] = "ON";
})(OnSiteStatus = exports.OnSiteStatus || (exports.OnSiteStatus = {}));
var OpeningType;
(function (OpeningType) {
    OpeningType["Tap"] = "tap";
    OpeningType["TwistAndGo"] = "twistAndGo";
})(OpeningType = exports.OpeningType || (exports.OpeningType = {}));
var OperationsRole;
(function (OperationsRole) {
    OperationsRole["AppointmentOrganizer"] = "APPOINTMENT_ORGANIZER";
    OperationsRole["AuthenticatedNoPermission"] = "AUTHENTICATED_NO_PERMISSION";
    OperationsRole["BuildingReceptionist"] = "BUILDING_RECEPTIONIST";
    OperationsRole["PropertyManager"] = "PROPERTY_MANAGER";
    OperationsRole["Service"] = "SERVICE";
    OperationsRole["TenantReceptionist"] = "TENANT_RECEPTIONIST";
    OperationsRole["WorkplaceManager"] = "WORKPLACE_MANAGER";
})(OperationsRole = exports.OperationsRole || (exports.OperationsRole = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Cancelled"] = "CANCELLED";
    OrderStatus["Completed"] = "COMPLETED";
    OrderStatus["InProgress"] = "IN_PROGRESS";
    OrderStatus["New"] = "NEW";
    OrderStatus["PaymentFailed"] = "PAYMENT_FAILED";
    OrderStatus["PaymentPending"] = "PAYMENT_PENDING";
    OrderStatus["Rejected"] = "REJECTED";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var OtpChallengeFailureReason;
(function (OtpChallengeFailureReason) {
    OtpChallengeFailureReason["EmailFailure"] = "EMAIL_FAILURE";
    OtpChallengeFailureReason["EmailVerificationRequired"] = "EMAIL_VERIFICATION_REQUIRED";
    OtpChallengeFailureReason["Unknown"] = "UNKNOWN";
})(OtpChallengeFailureReason = exports.OtpChallengeFailureReason || (exports.OtpChallengeFailureReason = {}));
var OtpChallengeRespondFailureReason;
(function (OtpChallengeRespondFailureReason) {
    OtpChallengeRespondFailureReason["Expired"] = "EXPIRED";
    OtpChallengeRespondFailureReason["InvalidOtp"] = "INVALID_OTP";
    OtpChallengeRespondFailureReason["Unknown"] = "UNKNOWN";
})(OtpChallengeRespondFailureReason = exports.OtpChallengeRespondFailureReason || (exports.OtpChallengeRespondFailureReason = {}));
var PageViewPageType;
(function (PageViewPageType) {
    PageViewPageType["Article"] = "ARTICLE";
    PageViewPageType["Booking"] = "BOOKING";
    PageViewPageType["Event"] = "EVENT";
    PageViewPageType["Home"] = "HOME";
    PageViewPageType["Info"] = "INFO";
    PageViewPageType["News"] = "NEWS";
    PageViewPageType["Profile"] = "PROFILE";
    PageViewPageType["Registration"] = "REGISTRATION";
    PageViewPageType["ResourceList"] = "RESOURCE_LIST";
    PageViewPageType["Static"] = "STATIC";
    PageViewPageType["Store"] = "STORE";
    PageViewPageType["VisitorManagement"] = "VISITOR_MANAGEMENT";
})(PageViewPageType = exports.PageViewPageType || (exports.PageViewPageType = {}));
var ParkingProvider;
(function (ParkingProvider) {
    ParkingProvider["None"] = "NONE";
    ParkingProvider["ParkOffice"] = "PARK_OFFICE";
    ParkingProvider["Ubipark"] = "UBIPARK";
})(ParkingProvider = exports.ParkingProvider || (exports.ParkingProvider = {}));
/** Enumeration of all the possible failure codes during payment */
var PaymentFailureCodes;
(function (PaymentFailureCodes) {
    PaymentFailureCodes["AmountTooLarge"] = "AMOUNT_TOO_LARGE";
    PaymentFailureCodes["AmountTooSmall"] = "AMOUNT_TOO_SMALL";
    PaymentFailureCodes["BalanceInsufficient"] = "BALANCE_INSUFFICIENT";
    PaymentFailureCodes["CardDeclined"] = "CARD_DECLINED";
    PaymentFailureCodes["ExpiredCard"] = "EXPIRED_CARD";
    PaymentFailureCodes["Other"] = "OTHER";
    PaymentFailureCodes["StripeRequestInput"] = "STRIPE_REQUEST_INPUT";
})(PaymentFailureCodes = exports.PaymentFailureCodes || (exports.PaymentFailureCodes = {}));
/** See https://stripe.com/docs/api/payment_intents/object#payment_intent_object-client_secret */
var PaymentIntentStatus;
(function (PaymentIntentStatus) {
    PaymentIntentStatus["Canceled"] = "CANCELED";
    PaymentIntentStatus["Processing"] = "PROCESSING";
    PaymentIntentStatus["RequiresAction"] = "REQUIRES_ACTION";
    PaymentIntentStatus["RequiresCapture"] = "REQUIRES_CAPTURE";
    PaymentIntentStatus["RequiresConfirmation"] = "REQUIRES_CONFIRMATION";
    PaymentIntentStatus["RequiresPaymentMethod"] = "REQUIRES_PAYMENT_METHOD";
    PaymentIntentStatus["Succeeded"] = "SUCCEEDED";
})(PaymentIntentStatus = exports.PaymentIntentStatus || (exports.PaymentIntentStatus = {}));
var PlatformType;
(function (PlatformType) {
    PlatformType["Mobile"] = "MOBILE";
    PlatformType["Web"] = "WEB";
})(PlatformType = exports.PlatformType || (exports.PlatformType = {}));
var PolicyChangeEventLogAction;
(function (PolicyChangeEventLogAction) {
    PolicyChangeEventLogAction["CookiePolicy"] = "COOKIE_POLICY";
    PolicyChangeEventLogAction["PrivacyPolicy"] = "PRIVACY_POLICY";
    PolicyChangeEventLogAction["TermsAndConditions"] = "TERMS_AND_CONDITIONS";
})(PolicyChangeEventLogAction = exports.PolicyChangeEventLogAction || (exports.PolicyChangeEventLogAction = {}));
var PollDurationInterval;
(function (PollDurationInterval) {
    PollDurationInterval["Days"] = "days";
    PollDurationInterval["Months"] = "months";
})(PollDurationInterval = exports.PollDurationInterval || (exports.PollDurationInterval = {}));
var PollQuestionType;
(function (PollQuestionType) {
    PollQuestionType["Comment"] = "Comment";
    PollQuestionType["MultipleChoice"] = "MultipleChoice";
    PollQuestionType["SingleChoice"] = "SingleChoice";
})(PollQuestionType = exports.PollQuestionType || (exports.PollQuestionType = {}));
var ProductSubscriptionStatus;
(function (ProductSubscriptionStatus) {
    ProductSubscriptionStatus["Active"] = "ACTIVE";
    ProductSubscriptionStatus["Cancelled"] = "CANCELLED";
})(ProductSubscriptionStatus = exports.ProductSubscriptionStatus || (exports.ProductSubscriptionStatus = {}));
var ProductSubscriptionStatusV2;
(function (ProductSubscriptionStatusV2) {
    ProductSubscriptionStatusV2["Active"] = "ACTIVE";
    ProductSubscriptionStatusV2["Cancelled"] = "CANCELLED";
    ProductSubscriptionStatusV2["Paused"] = "PAUSED";
})(ProductSubscriptionStatusV2 = exports.ProductSubscriptionStatusV2 || (exports.ProductSubscriptionStatusV2 = {}));
var ProductType;
(function (ProductType) {
    ProductType["BookableProduct"] = "BOOKABLE_PRODUCT";
    ProductType["PlainProduct"] = "PLAIN_PRODUCT";
    ProductType["SubscriptionProduct"] = "SUBSCRIPTION_PRODUCT";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var ProductVisibility;
(function (ProductVisibility) {
    ProductVisibility["Hidden"] = "HIDDEN";
    ProductVisibility["Live"] = "LIVE";
})(ProductVisibility = exports.ProductVisibility || (exports.ProductVisibility = {}));
var ProfileEventLogAction;
(function (ProfileEventLogAction) {
    ProfileEventLogAction["AttributeAdded"] = "ATTRIBUTE_ADDED";
    ProfileEventLogAction["AttributeRemoved"] = "ATTRIBUTE_REMOVED";
    ProfileEventLogAction["Comment"] = "COMMENT";
    ProfileEventLogAction["CompanyUpdated"] = "COMPANY_UPDATED";
    ProfileEventLogAction["CreditCardAdded"] = "CREDIT_CARD_ADDED";
    ProfileEventLogAction["CreditCardDeleted"] = "CREDIT_CARD_DELETED";
    ProfileEventLogAction["CsvExportRequestManagement"] = "CSV_EXPORT_REQUEST_MANAGEMENT";
    ProfileEventLogAction["DeactivationReminderSent"] = "DEACTIVATION_REMINDER_SENT";
    ProfileEventLogAction["EmailSubscriptionChanged"] = "EMAIL_SUBSCRIPTION_CHANGED";
    ProfileEventLogAction["EmailUpdated"] = "EMAIL_UPDATED";
    ProfileEventLogAction["EmailVerificationRequested"] = "EMAIL_VERIFICATION_REQUESTED";
    ProfileEventLogAction["MobileNumberUpdated"] = "MOBILE_NUMBER_UPDATED";
    ProfileEventLogAction["NotificationSubscriptionChanged"] = "NOTIFICATION_SUBSCRIPTION_CHANGED";
    ProfileEventLogAction["PasswordReset"] = "PASSWORD_RESET";
    ProfileEventLogAction["PermissionAdded"] = "PERMISSION_ADDED";
    ProfileEventLogAction["PermissionRemoved"] = "PERMISSION_REMOVED";
    ProfileEventLogAction["RoleAdded"] = "ROLE_ADDED";
    ProfileEventLogAction["RoleRemoved"] = "ROLE_REMOVED";
    ProfileEventLogAction["SiteProfileAdded"] = "SITE_PROFILE_ADDED";
    ProfileEventLogAction["SiteProfileRemoved"] = "SITE_PROFILE_REMOVED";
    ProfileEventLogAction["StatusUpdated"] = "STATUS_UPDATED";
    ProfileEventLogAction["UserDisabled"] = "USER_DISABLED";
})(ProfileEventLogAction = exports.ProfileEventLogAction || (exports.ProfileEventLogAction = {}));
var ProfileHistorySortField;
(function (ProfileHistorySortField) {
    ProfileHistorySortField["Timestamp"] = "TIMESTAMP";
})(ProfileHistorySortField = exports.ProfileHistorySortField || (exports.ProfileHistorySortField = {}));
var ProfileReadyCheckStatus;
(function (ProfileReadyCheckStatus) {
    ProfileReadyCheckStatus["Done"] = "DONE";
    ProfileReadyCheckStatus["Failed"] = "FAILED";
    ProfileReadyCheckStatus["InProgress"] = "IN_PROGRESS";
})(ProfileReadyCheckStatus = exports.ProfileReadyCheckStatus || (exports.ProfileReadyCheckStatus = {}));
var ProfileRegistrationType;
(function (ProfileRegistrationType) {
    ProfileRegistrationType["Commercial"] = "COMMERCIAL";
    ProfileRegistrationType["Residential"] = "RESIDENTIAL";
    ProfileRegistrationType["Visitor"] = "VISITOR";
})(ProfileRegistrationType = exports.ProfileRegistrationType || (exports.ProfileRegistrationType = {}));
var ProfileRole;
(function (ProfileRole) {
    ProfileRole["AccessAttendeeReport"] = "AccessAttendeeReport";
})(ProfileRole = exports.ProfileRole || (exports.ProfileRole = {}));
var ProfileSortField;
(function (ProfileSortField) {
    ProfileSortField["Company"] = "COMPANY";
    ProfileSortField["Email"] = "EMAIL";
    ProfileSortField["LastSeen"] = "LAST_SEEN";
    ProfileSortField["Name"] = "NAME";
    ProfileSortField["Status"] = "STATUS";
})(ProfileSortField = exports.ProfileSortField || (exports.ProfileSortField = {}));
var ProfileStatus;
(function (ProfileStatus) {
    ProfileStatus["Active"] = "ACTIVE";
    ProfileStatus["Deactivated"] = "DEACTIVATED";
    ProfileStatus["PendingApproval"] = "PENDING_APPROVAL";
})(ProfileStatus = exports.ProfileStatus || (exports.ProfileStatus = {}));
var PropertyManagerEquiemOneMetrics;
(function (PropertyManagerEquiemOneMetrics) {
    PropertyManagerEquiemOneMetrics["ActiveUsers"] = "ActiveUsers";
    PropertyManagerEquiemOneMetrics["NewsletterOpenRate"] = "NewsletterOpenRate";
    PropertyManagerEquiemOneMetrics["Registrations"] = "Registrations";
})(PropertyManagerEquiemOneMetrics = exports.PropertyManagerEquiemOneMetrics || (exports.PropertyManagerEquiemOneMetrics = {}));
var PubSubRole;
(function (PubSubRole) {
    PubSubRole["Anon"] = "ANON";
    PubSubRole["Service"] = "SERVICE";
    PubSubRole["User"] = "USER";
})(PubSubRole = exports.PubSubRole || (exports.PubSubRole = {}));
var PublicationAuthorType;
(function (PublicationAuthorType) {
    PublicationAuthorType["CustomAuthor"] = "customAuthor";
    PublicationAuthorType["SiteDefaultAuthor"] = "siteDefaultAuthor";
})(PublicationAuthorType = exports.PublicationAuthorType || (exports.PublicationAuthorType = {}));
var PublicationDateType;
(function (PublicationDateType) {
    PublicationDateType["PublishLater"] = "publishLater";
    PublicationDateType["PublishNow"] = "publishNow";
})(PublicationDateType = exports.PublicationDateType || (exports.PublicationDateType = {}));
var RefundBookingItemType;
(function (RefundBookingItemType) {
    RefundBookingItemType["AddOn"] = "AddOn";
    RefundBookingItemType["Adjustment"] = "Adjustment";
    RefundBookingItemType["Booking"] = "Booking";
})(RefundBookingItemType = exports.RefundBookingItemType || (exports.RefundBookingItemType = {}));
var RegistrationType;
(function (RegistrationType) {
    RegistrationType["Commercial"] = "COMMERCIAL";
    RegistrationType["Residential"] = "RESIDENTIAL";
    RegistrationType["Visitor"] = "VISITOR";
})(RegistrationType = exports.RegistrationType || (exports.RegistrationType = {}));
var ReqMgtBuildingsQueryRole;
(function (ReqMgtBuildingsQueryRole) {
    ReqMgtBuildingsQueryRole["RequestManager"] = "REQUEST_MANAGER";
})(ReqMgtBuildingsQueryRole = exports.ReqMgtBuildingsQueryRole || (exports.ReqMgtBuildingsQueryRole = {}));
var ReqMgtCafmConfigurationType;
(function (ReqMgtCafmConfigurationType) {
    ReqMgtCafmConfigurationType["ConceptEvolution"] = "ConceptEvolution";
    ReqMgtCafmConfigurationType["Elogbooks"] = "Elogbooks";
    ReqMgtCafmConfigurationType["Excell"] = "Excell";
    ReqMgtCafmConfigurationType["Facilio"] = "Facilio";
    ReqMgtCafmConfigurationType["Maximo"] = "Maximo";
    ReqMgtCafmConfigurationType["NgBailey"] = "NGBailey";
    ReqMgtCafmConfigurationType["Simpro"] = "Simpro";
})(ReqMgtCafmConfigurationType = exports.ReqMgtCafmConfigurationType || (exports.ReqMgtCafmConfigurationType = {}));
var ReqMgtFiltersQueryRole;
(function (ReqMgtFiltersQueryRole) {
    ReqMgtFiltersQueryRole["FlexManager"] = "FLEX_MANAGER";
    ReqMgtFiltersQueryRole["PropertyManager"] = "PROPERTY_MANAGER";
    ReqMgtFiltersQueryRole["RequestAssignee"] = "REQUEST_ASSIGNEE";
    ReqMgtFiltersQueryRole["RequestManager"] = "REQUEST_MANAGER";
    ReqMgtFiltersQueryRole["WorkplaceManager"] = "WORKPLACE_MANAGER";
})(ReqMgtFiltersQueryRole = exports.ReqMgtFiltersQueryRole || (exports.ReqMgtFiltersQueryRole = {}));
var ReqMgtPriority;
(function (ReqMgtPriority) {
    ReqMgtPriority["High"] = "HIGH";
    ReqMgtPriority["Low"] = "LOW";
    ReqMgtPriority["Medium"] = "MEDIUM";
    ReqMgtPriority["Urgent"] = "URGENT";
})(ReqMgtPriority = exports.ReqMgtPriority || (exports.ReqMgtPriority = {}));
var ReqMgtRequestsFilterScope;
(function (ReqMgtRequestsFilterScope) {
    ReqMgtRequestsFilterScope["All"] = "All";
    ReqMgtRequestsFilterScope["Assigned"] = "Assigned";
    ReqMgtRequestsFilterScope["My"] = "My";
})(ReqMgtRequestsFilterScope = exports.ReqMgtRequestsFilterScope || (exports.ReqMgtRequestsFilterScope = {}));
var ReqMgtRole;
(function (ReqMgtRole) {
    ReqMgtRole["Anon"] = "ANON";
    ReqMgtRole["Service"] = "SERVICE";
    ReqMgtRole["User"] = "USER";
})(ReqMgtRole = exports.ReqMgtRole || (exports.ReqMgtRole = {}));
var ReqMgtSortField;
(function (ReqMgtSortField) {
    ReqMgtSortField["Created"] = "CREATED";
    ReqMgtSortField["Priority"] = "PRIORITY";
    ReqMgtSortField["Reference"] = "REFERENCE";
    ReqMgtSortField["Updated"] = "UPDATED";
})(ReqMgtSortField = exports.ReqMgtSortField || (exports.ReqMgtSortField = {}));
var ReqMgtStatusType;
(function (ReqMgtStatusType) {
    ReqMgtStatusType["Completed"] = "COMPLETED";
    ReqMgtStatusType["InProgress"] = "IN_PROGRESS";
    ReqMgtStatusType["NotStarted"] = "NOT_STARTED";
})(ReqMgtStatusType = exports.ReqMgtStatusType || (exports.ReqMgtStatusType = {}));
var Role;
(function (Role) {
    Role["Authenticated"] = "AUTHENTICATED";
    Role["AccessAttendeeReport"] = "AccessAttendeeReport";
    Role["Guest"] = "Guest";
    Role["Service"] = "SERVICE";
})(Role = exports.Role || (exports.Role = {}));
var SearchContentType;
(function (SearchContentType) {
    SearchContentType["Article"] = "ARTICLE";
    SearchContentType["BookableProduct"] = "BOOKABLE_PRODUCT";
    SearchContentType["BookableResource"] = "BOOKABLE_RESOURCE";
    SearchContentType["BuildingInfoPost"] = "BUILDING_INFO_POST";
    SearchContentType["DealProduct"] = "DEAL_PRODUCT";
    SearchContentType["DealVendor"] = "DEAL_VENDOR";
    SearchContentType["EventPost"] = "EVENT_POST";
    SearchContentType["Feedback"] = "FEEDBACK";
    SearchContentType["NewsPost"] = "NEWS_POST";
    SearchContentType["PlainProduct"] = "PLAIN_PRODUCT";
    SearchContentType["Poll"] = "POLL";
    SearchContentType["QuickLink"] = "QUICK_LINK";
    SearchContentType["SubscriptionProduct"] = "SUBSCRIPTION_PRODUCT";
    SearchContentType["Vendor"] = "VENDOR";
})(SearchContentType = exports.SearchContentType || (exports.SearchContentType = {}));
var SegmentationFilterItemType;
(function (SegmentationFilterItemType) {
    SegmentationFilterItemType["Apartment"] = "APARTMENT";
    SegmentationFilterItemType["Area"] = "AREA";
    SegmentationFilterItemType["Building"] = "BUILDING";
    SegmentationFilterItemType["Company"] = "COMPANY";
    SegmentationFilterItemType["CompanyAttribute"] = "COMPANY_ATTRIBUTE";
    SegmentationFilterItemType["FlexOperator"] = "FLEX_OPERATOR";
    SegmentationFilterItemType["FlexTenant"] = "FLEX_TENANT";
    SegmentationFilterItemType["Level"] = "LEVEL";
    SegmentationFilterItemType["PermissionRole"] = "PERMISSION_ROLE";
    SegmentationFilterItemType["Role"] = "ROLE";
    SegmentationFilterItemType["UserAttribute"] = "USER_ATTRIBUTE";
})(SegmentationFilterItemType = exports.SegmentationFilterItemType || (exports.SegmentationFilterItemType = {}));
var SegmentationRegistrationType;
(function (SegmentationRegistrationType) {
    SegmentationRegistrationType["Commercial"] = "COMMERCIAL";
    SegmentationRegistrationType["Residential"] = "RESIDENTIAL";
    SegmentationRegistrationType["Visitor"] = "VISITOR";
})(SegmentationRegistrationType = exports.SegmentationRegistrationType || (exports.SegmentationRegistrationType = {}));
var SegmentationRole;
(function (SegmentationRole) {
    SegmentationRole["Service"] = "SERVICE";
    SegmentationRole["User"] = "USER";
})(SegmentationRole = exports.SegmentationRole || (exports.SegmentationRole = {}));
var SmsChallengeFailureReason;
(function (SmsChallengeFailureReason) {
    SmsChallengeFailureReason["InvalidNumber"] = "INVALID_NUMBER";
    SmsChallengeFailureReason["SmsDisabled"] = "SMS_DISABLED";
    SmsChallengeFailureReason["Unknown"] = "UNKNOWN";
})(SmsChallengeFailureReason = exports.SmsChallengeFailureReason || (exports.SmsChallengeFailureReason = {}));
var SmsChallengeRespondFailureReason;
(function (SmsChallengeRespondFailureReason) {
    SmsChallengeRespondFailureReason["Expired"] = "EXPIRED";
    SmsChallengeRespondFailureReason["InvalidOtp"] = "INVALID_OTP";
    SmsChallengeRespondFailureReason["Unknown"] = "UNKNOWN";
})(SmsChallengeRespondFailureReason = exports.SmsChallengeRespondFailureReason || (exports.SmsChallengeRespondFailureReason = {}));
var SocialLinkType;
(function (SocialLinkType) {
    SocialLinkType["Email"] = "EMAIL";
    SocialLinkType["Facebook"] = "FACEBOOK";
    SocialLinkType["Instagram"] = "INSTAGRAM";
    SocialLinkType["Linkedin"] = "LINKEDIN";
    SocialLinkType["Other"] = "OTHER";
    SocialLinkType["Phone"] = "PHONE";
    SocialLinkType["Twitter"] = "TWITTER";
})(SocialLinkType = exports.SocialLinkType || (exports.SocialLinkType = {}));
var SpaceVisibilityType;
(function (SpaceVisibilityType) {
    SpaceVisibilityType["Custom"] = "CUSTOM";
    SpaceVisibilityType["Members"] = "MEMBERS";
    SpaceVisibilityType["Private"] = "PRIVATE";
    SpaceVisibilityType["Public"] = "PUBLIC";
})(SpaceVisibilityType = exports.SpaceVisibilityType || (exports.SpaceVisibilityType = {}));
var StatsProviderVisitorAppointmentType;
(function (StatsProviderVisitorAppointmentType) {
    StatsProviderVisitorAppointmentType["EveryDay"] = "EveryDay";
    StatsProviderVisitorAppointmentType["EveryMonth"] = "EveryMonth";
    StatsProviderVisitorAppointmentType["EveryWeek"] = "EveryWeek";
    StatsProviderVisitorAppointmentType["PreBooked"] = "PreBooked";
    StatsProviderVisitorAppointmentType["WalkIn"] = "WalkIn";
})(StatsProviderVisitorAppointmentType = exports.StatsProviderVisitorAppointmentType || (exports.StatsProviderVisitorAppointmentType = {}));
var StatsProviderVisitorType;
(function (StatsProviderVisitorType) {
    StatsProviderVisitorType["Contractor"] = "Contractor";
    StatsProviderVisitorType["Employee"] = "Employee";
    StatsProviderVisitorType["Visitor"] = "Visitor";
})(StatsProviderVisitorType = exports.StatsProviderVisitorType || (exports.StatsProviderVisitorType = {}));
var StepStatus;
(function (StepStatus) {
    StepStatus["Completed"] = "COMPLETED";
    StepStatus["InProgress"] = "IN_PROGRESS";
    StepStatus["Pending"] = "PENDING";
})(StepStatus = exports.StepStatus || (exports.StepStatus = {}));
var StoreRole;
(function (StoreRole) {
    StoreRole["Customer"] = "CUSTOMER";
    StoreRole["EquiemAdmin"] = "EQUIEM_ADMIN";
    StoreRole["Service"] = "SERVICE";
    StoreRole["SiteManager"] = "SITE_MANAGER";
    StoreRole["VendorUser"] = "VENDOR_USER";
})(StoreRole = exports.StoreRole || (exports.StoreRole = {}));
var StoreUserPermission;
(function (StoreUserPermission) {
    StoreUserPermission["AccessReports"] = "ACCESS_REPORTS";
    StoreUserPermission["CreateDealsVendor"] = "CREATE_DEALS_VENDOR";
    StoreUserPermission["EditSiteSettings"] = "EDIT_SITE_SETTINGS";
    StoreUserPermission["EditStoreSettings"] = "EDIT_STORE_SETTINGS";
    StoreUserPermission["ManageDiscounts"] = "MANAGE_DISCOUNTS";
    StoreUserPermission["ManageMenu"] = "MANAGE_MENU";
    StoreUserPermission["ManageOrder"] = "MANAGE_ORDER";
    StoreUserPermission["ManageUsers"] = "MANAGE_USERS";
    StoreUserPermission["ManageVendors"] = "MANAGE_VENDORS";
    StoreUserPermission["ManuallyAdjustOrder"] = "MANUALLY_ADJUST_ORDER";
    /** deprecated. Use MANUALLY_ADJUST_ORDER instead */
    StoreUserPermission["RefundOrder"] = "REFUND_ORDER";
})(StoreUserPermission = exports.StoreUserPermission || (exports.StoreUserPermission = {}));
var SubscriptionBillingCycle;
(function (SubscriptionBillingCycle) {
    SubscriptionBillingCycle["Monthly"] = "MONTHLY";
    SubscriptionBillingCycle["Weekly"] = "WEEKLY";
})(SubscriptionBillingCycle = exports.SubscriptionBillingCycle || (exports.SubscriptionBillingCycle = {}));
var SubscriptionPaymentStatus;
(function (SubscriptionPaymentStatus) {
    SubscriptionPaymentStatus["Failed"] = "FAILED";
    SubscriptionPaymentStatus["PaymentPending"] = "PAYMENT_PENDING";
    SubscriptionPaymentStatus["RequiresAction"] = "REQUIRES_ACTION";
    SubscriptionPaymentStatus["Successful"] = "SUCCESSFUL";
})(SubscriptionPaymentStatus = exports.SubscriptionPaymentStatus || (exports.SubscriptionPaymentStatus = {}));
var SwiftConnectSdkType;
(function (SwiftConnectSdkType) {
    SwiftConnectSdkType["SwiftConnectHidsdk"] = "SwiftConnectHIDSDK";
    SwiftConnectSdkType["SwiftConnectMobileCredentialsSdk"] = "SwiftConnectMobileCredentialsSDK";
})(SwiftConnectSdkType = exports.SwiftConnectSdkType || (exports.SwiftConnectSdkType = {}));
var SyncStatus;
(function (SyncStatus) {
    SyncStatus["Deleted"] = "DELETED";
    SyncStatus["DeleteRequested"] = "DELETE_REQUESTED";
    SyncStatus["NotScheduled"] = "NOT_SCHEDULED";
    SyncStatus["Synced"] = "SYNCED";
    SyncStatus["SyncRequested"] = "SYNC_REQUESTED";
})(SyncStatus = exports.SyncStatus || (exports.SyncStatus = {}));
var SyndicateRole;
(function (SyndicateRole) {
    SyndicateRole["Auth0"] = "AUTH0";
    SyndicateRole["Service"] = "SERVICE";
})(SyndicateRole = exports.SyndicateRole || (exports.SyndicateRole = {}));
var TabName;
(function (TabName) {
    TabName["BuildingInfo"] = "BUILDING_INFO";
    TabName["Event"] = "EVENT";
    TabName["Home"] = "HOME";
    TabName["News"] = "NEWS";
    TabName["NewsEvents"] = "NEWS_EVENTS";
    TabName["Passes"] = "PASSES";
    TabName["Profile"] = "PROFILE";
    TabName["Store"] = "STORE";
})(TabName = exports.TabName || (exports.TabName = {}));
var UiWidgetType;
(function (UiWidgetType) {
    UiWidgetType["Booking"] = "BOOKING";
    UiWidgetType["Curated"] = "CURATED";
    UiWidgetType["Discount"] = "DISCOUNT";
    UiWidgetType["Events"] = "EVENTS";
    UiWidgetType["Featured"] = "FEATURED";
    UiWidgetType["Feedback"] = "FEEDBACK";
    UiWidgetType["Forme"] = "FORME";
    UiWidgetType["News"] = "NEWS";
    UiWidgetType["Popular"] = "POPULAR";
    UiWidgetType["Quicklinks"] = "QUICKLINKS";
    UiWidgetType["Reorder"] = "REORDER";
    UiWidgetType["Transport"] = "TRANSPORT";
    UiWidgetType["Trending"] = "TRENDING";
})(UiWidgetType = exports.UiWidgetType || (exports.UiWidgetType = {}));
var UserIndexFieldGroups;
(function (UserIndexFieldGroups) {
    UserIndexFieldGroups["AuthorizationRoles"] = "AUTHORIZATION_ROLES";
    UserIndexFieldGroups["Base"] = "BASE";
})(UserIndexFieldGroups = exports.UserIndexFieldGroups || (exports.UserIndexFieldGroups = {}));
var UserRole;
(function (UserRole) {
    UserRole["Anon"] = "ANON";
    UserRole["Service"] = "SERVICE";
    UserRole["User"] = "USER";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var UserSortField;
(function (UserSortField) {
    UserSortField["Company"] = "COMPANY";
    UserSortField["Email"] = "EMAIL";
    UserSortField["LastSeen"] = "LAST_SEEN";
    UserSortField["Name"] = "NAME";
    UserSortField["Status"] = "STATUS";
})(UserSortField = exports.UserSortField || (exports.UserSortField = {}));
var UserSortFieldV2;
(function (UserSortFieldV2) {
    UserSortFieldV2["Active"] = "active";
    UserSortFieldV2["CompanyNameKeywords"] = "companyNameKeywords";
    UserSortFieldV2["EmailKeyword"] = "emailKeyword";
    UserSortFieldV2["FirstNameKeyword"] = "firstNameKeyword";
    UserSortFieldV2["ProfileLastActiveAt"] = "profileLastActiveAt";
})(UserSortFieldV2 = exports.UserSortFieldV2 || (exports.UserSortFieldV2 = {}));
var ValidateBookingTimesStatus;
(function (ValidateBookingTimesStatus) {
    ValidateBookingTimesStatus["Available"] = "Available";
    ValidateBookingTimesStatus["OutOfAvailability"] = "OutOfAvailability";
    ValidateBookingTimesStatus["Taken"] = "Taken";
})(ValidateBookingTimesStatus = exports.ValidateBookingTimesStatus || (exports.ValidateBookingTimesStatus = {}));
var ValidateResetPasswordErrorCode;
(function (ValidateResetPasswordErrorCode) {
    ValidateResetPasswordErrorCode["TokenExpired"] = "TOKEN_EXPIRED";
    ValidateResetPasswordErrorCode["TokenNotFound"] = "TOKEN_NOT_FOUND";
    ValidateResetPasswordErrorCode["Unknown"] = "UNKNOWN";
})(ValidateResetPasswordErrorCode = exports.ValidateResetPasswordErrorCode || (exports.ValidateResetPasswordErrorCode = {}));
var VendorProductsSearchBy;
(function (VendorProductsSearchBy) {
    VendorProductsSearchBy["Description"] = "DESCRIPTION";
    VendorProductsSearchBy["Name"] = "NAME";
})(VendorProductsSearchBy = exports.VendorProductsSearchBy || (exports.VendorProductsSearchBy = {}));
var VendorSortableFields;
(function (VendorSortableFields) {
    VendorSortableFields["Name"] = "NAME";
    VendorSortableFields["Sites"] = "SITES";
    VendorSortableFields["Status"] = "STATUS";
    VendorSortableFields["StripeConnected"] = "STRIPE_CONNECTED";
})(VendorSortableFields = exports.VendorSortableFields || (exports.VendorSortableFields = {}));
var VendorVisibilityStatus;
(function (VendorVisibilityStatus) {
    VendorVisibilityStatus["Hidden"] = "HIDDEN";
    VendorVisibilityStatus["Live"] = "LIVE";
})(VendorVisibilityStatus = exports.VendorVisibilityStatus || (exports.VendorVisibilityStatus = {}));
var ViciniteeRole;
(function (ViciniteeRole) {
    ViciniteeRole["Service"] = "SERVICE";
    ViciniteeRole["User"] = "USER";
})(ViciniteeRole = exports.ViciniteeRole || (exports.ViciniteeRole = {}));
var VisitorAppointmentRecurringType;
(function (VisitorAppointmentRecurringType) {
    VisitorAppointmentRecurringType["Daily"] = "DAILY";
    VisitorAppointmentRecurringType["Monthly"] = "MONTHLY";
    VisitorAppointmentRecurringType["Weekly"] = "WEEKLY";
})(VisitorAppointmentRecurringType = exports.VisitorAppointmentRecurringType || (exports.VisitorAppointmentRecurringType = {}));
var VisitorAppointmentType;
(function (VisitorAppointmentType) {
    VisitorAppointmentType["PreBooked"] = "PRE_BOOKED";
    VisitorAppointmentType["WalkIn"] = "WALK_IN";
})(VisitorAppointmentType = exports.VisitorAppointmentType || (exports.VisitorAppointmentType = {}));
var VisitorAppointmentWeekday;
(function (VisitorAppointmentWeekday) {
    VisitorAppointmentWeekday["Friday"] = "FRIDAY";
    VisitorAppointmentWeekday["Monday"] = "MONDAY";
    VisitorAppointmentWeekday["Saturday"] = "SATURDAY";
    VisitorAppointmentWeekday["Sunday"] = "SUNDAY";
    VisitorAppointmentWeekday["Thursday"] = "THURSDAY";
    VisitorAppointmentWeekday["Tuesday"] = "TUESDAY";
    VisitorAppointmentWeekday["Wednesday"] = "WEDNESDAY";
})(VisitorAppointmentWeekday = exports.VisitorAppointmentWeekday || (exports.VisitorAppointmentWeekday = {}));
var VisitorAppointmentsQueryRole;
(function (VisitorAppointmentsQueryRole) {
    VisitorAppointmentsQueryRole["PropertyManager"] = "PROPERTY_MANAGER";
    VisitorAppointmentsQueryRole["WorkplaceManager"] = "WORKPLACE_MANAGER";
})(VisitorAppointmentsQueryRole = exports.VisitorAppointmentsQueryRole || (exports.VisitorAppointmentsQueryRole = {}));
var VisitorAppointmentsSortField;
(function (VisitorAppointmentsSortField) {
    VisitorAppointmentsSortField["Date"] = "DATE";
})(VisitorAppointmentsSortField = exports.VisitorAppointmentsSortField || (exports.VisitorAppointmentsSortField = {}));
var VisitorInfo;
(function (VisitorInfo) {
    VisitorInfo["RequireAssistance"] = "REQUIRE_ASSISTANCE";
    VisitorInfo["Vip"] = "VIP";
})(VisitorInfo = exports.VisitorInfo || (exports.VisitorInfo = {}));
var VisitorRole;
(function (VisitorRole) {
    VisitorRole["PropertyManager"] = "PROPERTY_MANAGER";
    VisitorRole["Receptionist"] = "RECEPTIONIST";
    VisitorRole["WorkplaceManager"] = "WORKPLACE_MANAGER";
})(VisitorRole = exports.VisitorRole || (exports.VisitorRole = {}));
var VisitorStatus;
(function (VisitorStatus) {
    VisitorStatus["CardIdAssigned"] = "CARD_ID_ASSIGNED";
    VisitorStatus["CheckedIn"] = "CHECKED_IN";
    VisitorStatus["CheckedOut"] = "CHECKED_OUT";
    VisitorStatus["PreBooked"] = "PRE_BOOKED";
    VisitorStatus["VisitorInLobby"] = "VISITOR_IN_LOBBY";
})(VisitorStatus = exports.VisitorStatus || (exports.VisitorStatus = {}));
var VmsAdjustmentFailureCodesV2;
(function (VmsAdjustmentFailureCodesV2) {
    VmsAdjustmentFailureCodesV2["AmountTooLarge"] = "AMOUNT_TOO_LARGE";
    VmsAdjustmentFailureCodesV2["AmountTooSmall"] = "AMOUNT_TOO_SMALL";
    VmsAdjustmentFailureCodesV2["AuthenticationRequired"] = "AUTHENTICATION_REQUIRED";
    VmsAdjustmentFailureCodesV2["BalanceInsufficient"] = "BALANCE_INSUFFICIENT";
    VmsAdjustmentFailureCodesV2["CardDeclined"] = "CARD_DECLINED";
    VmsAdjustmentFailureCodesV2["ExpiredCard"] = "EXPIRED_CARD";
    VmsAdjustmentFailureCodesV2["Other"] = "OTHER";
    VmsAdjustmentFailureCodesV2["StripeRequestInput"] = "STRIPE_REQUEST_INPUT";
})(VmsAdjustmentFailureCodesV2 = exports.VmsAdjustmentFailureCodesV2 || (exports.VmsAdjustmentFailureCodesV2 = {}));
var VmsChoicesSearchBy;
(function (VmsChoicesSearchBy) {
    VmsChoicesSearchBy["Name"] = "NAME";
})(VmsChoicesSearchBy = exports.VmsChoicesSearchBy || (exports.VmsChoicesSearchBy = {}));
/** Day of the week for opening hours */
var VmsDayOfTheWeek;
(function (VmsDayOfTheWeek) {
    VmsDayOfTheWeek["Friday"] = "FRIDAY";
    VmsDayOfTheWeek["Monday"] = "MONDAY";
    VmsDayOfTheWeek["Saturday"] = "SATURDAY";
    VmsDayOfTheWeek["Sunday"] = "SUNDAY";
    VmsDayOfTheWeek["Thursday"] = "THURSDAY";
    VmsDayOfTheWeek["Tuesday"] = "TUESDAY";
    VmsDayOfTheWeek["Wednesday"] = "WEDNESDAY";
})(VmsDayOfTheWeek = exports.VmsDayOfTheWeek || (exports.VmsDayOfTheWeek = {}));
var VmsDealType;
(function (VmsDealType) {
    VmsDealType["AffiliateLink"] = "AFFILIATE_LINK";
    VmsDealType["NonRedeemable"] = "NON_REDEEMABLE";
    VmsDealType["Redeemable"] = "REDEEMABLE";
})(VmsDealType = exports.VmsDealType || (exports.VmsDealType = {}));
var VmsDealVendorSortableFields;
(function (VmsDealVendorSortableFields) {
    VmsDealVendorSortableFields["Name"] = "NAME";
    VmsDealVendorSortableFields["Sites"] = "SITES";
    VmsDealVendorSortableFields["Status"] = "STATUS";
})(VmsDealVendorSortableFields = exports.VmsDealVendorSortableFields || (exports.VmsDealVendorSortableFields = {}));
var VmsDeliveryType;
(function (VmsDeliveryType) {
    VmsDeliveryType["Delivery"] = "DELIVERY";
    VmsDeliveryType["Pickup"] = "PICKUP";
})(VmsDeliveryType = exports.VmsDeliveryType || (exports.VmsDeliveryType = {}));
var VmsDiscountStatus;
(function (VmsDiscountStatus) {
    VmsDiscountStatus["Active"] = "ACTIVE";
    VmsDiscountStatus["Completed"] = "COMPLETED";
    VmsDiscountStatus["Inactive"] = "INACTIVE";
})(VmsDiscountStatus = exports.VmsDiscountStatus || (exports.VmsDiscountStatus = {}));
var VmsDiscountType;
(function (VmsDiscountType) {
    VmsDiscountType["Amount"] = "AMOUNT";
    VmsDiscountType["Percentage"] = "PERCENTAGE";
})(VmsDiscountType = exports.VmsDiscountType || (exports.VmsDiscountType = {}));
var VmsImagePreset;
(function (VmsImagePreset) {
    VmsImagePreset["Thumbnail"] = "THUMBNAIL";
})(VmsImagePreset = exports.VmsImagePreset || (exports.VmsImagePreset = {}));
var VmsImageType;
(function (VmsImageType) {
    VmsImageType["Gif"] = "GIF";
    VmsImageType["Jpeg"] = "JPEG";
    VmsImageType["Png"] = "PNG";
})(VmsImageType = exports.VmsImageType || (exports.VmsImageType = {}));
var VmsModType;
(function (VmsModType) {
    VmsModType["FreeText"] = "FREE_TEXT";
    VmsModType["MultiChoice"] = "MULTI_CHOICE";
    VmsModType["SingleChoice"] = "SINGLE_CHOICE";
})(VmsModType = exports.VmsModType || (exports.VmsModType = {}));
var VmsOrderSortByField;
(function (VmsOrderSortByField) {
    VmsOrderSortByField["Created"] = "CREATED";
    VmsOrderSortByField["Eta"] = "ETA";
})(VmsOrderSortByField = exports.VmsOrderSortByField || (exports.VmsOrderSortByField = {}));
var VmsOrderStatus;
(function (VmsOrderStatus) {
    VmsOrderStatus["Cancelled"] = "CANCELLED";
    VmsOrderStatus["Completed"] = "COMPLETED";
    VmsOrderStatus["InProgress"] = "IN_PROGRESS";
    VmsOrderStatus["New"] = "NEW";
    VmsOrderStatus["PaymentFailed"] = "PAYMENT_FAILED";
    VmsOrderStatus["PaymentPending"] = "PAYMENT_PENDING";
    VmsOrderStatus["Rejected"] = "REJECTED";
})(VmsOrderStatus = exports.VmsOrderStatus || (exports.VmsOrderStatus = {}));
var VmsPauseOrResumeSubscriptionAction;
(function (VmsPauseOrResumeSubscriptionAction) {
    VmsPauseOrResumeSubscriptionAction["Pause"] = "Pause";
    VmsPauseOrResumeSubscriptionAction["Resume"] = "Resume";
})(VmsPauseOrResumeSubscriptionAction = exports.VmsPauseOrResumeSubscriptionAction || (exports.VmsPauseOrResumeSubscriptionAction = {}));
/** Enumeration of all the possible failure codes during payment */
var VmsPaymentFailureCodes;
(function (VmsPaymentFailureCodes) {
    VmsPaymentFailureCodes["AmountTooLarge"] = "AMOUNT_TOO_LARGE";
    VmsPaymentFailureCodes["AmountTooSmall"] = "AMOUNT_TOO_SMALL";
    VmsPaymentFailureCodes["BalanceInsufficient"] = "BALANCE_INSUFFICIENT";
    VmsPaymentFailureCodes["CardDeclined"] = "CARD_DECLINED";
    VmsPaymentFailureCodes["ExpiredCard"] = "EXPIRED_CARD";
    VmsPaymentFailureCodes["Other"] = "OTHER";
    VmsPaymentFailureCodes["StripeRequestInput"] = "STRIPE_REQUEST_INPUT";
})(VmsPaymentFailureCodes = exports.VmsPaymentFailureCodes || (exports.VmsPaymentFailureCodes = {}));
/** See https://stripe.com/docs/api/payment_intents/object#payment_intent_object-client_secret */
var VmsPaymentIntentStatus;
(function (VmsPaymentIntentStatus) {
    VmsPaymentIntentStatus["Canceled"] = "CANCELED";
    VmsPaymentIntentStatus["Processing"] = "PROCESSING";
    VmsPaymentIntentStatus["RequiresAction"] = "REQUIRES_ACTION";
    VmsPaymentIntentStatus["RequiresCapture"] = "REQUIRES_CAPTURE";
    VmsPaymentIntentStatus["RequiresConfirmation"] = "REQUIRES_CONFIRMATION";
    VmsPaymentIntentStatus["RequiresPaymentMethod"] = "REQUIRES_PAYMENT_METHOD";
    VmsPaymentIntentStatus["Succeeded"] = "SUCCEEDED";
})(VmsPaymentIntentStatus = exports.VmsPaymentIntentStatus || (exports.VmsPaymentIntentStatus = {}));
/** Permission type. Eg. VendorUserPermission/SiteUserPermission */
var VmsPermissionType;
(function (VmsPermissionType) {
    VmsPermissionType["SiteUserPermission"] = "SiteUserPermission";
    VmsPermissionType["VendorUserPermission"] = "VendorUserPermission";
})(VmsPermissionType = exports.VmsPermissionType || (exports.VmsPermissionType = {}));
var VmsPolicyType;
(function (VmsPolicyType) {
    VmsPolicyType["AppPrivacy"] = "APP_PRIVACY";
    VmsPolicyType["AppTerms"] = "APP_TERMS";
    VmsPolicyType["VendorTerms"] = "VENDOR_TERMS";
})(VmsPolicyType = exports.VmsPolicyType || (exports.VmsPolicyType = {}));
var VmsProductSubscriptionStatus;
(function (VmsProductSubscriptionStatus) {
    VmsProductSubscriptionStatus["Active"] = "ACTIVE";
    VmsProductSubscriptionStatus["Cancelled"] = "CANCELLED";
})(VmsProductSubscriptionStatus = exports.VmsProductSubscriptionStatus || (exports.VmsProductSubscriptionStatus = {}));
var VmsProductSubscriptionStatusV2;
(function (VmsProductSubscriptionStatusV2) {
    VmsProductSubscriptionStatusV2["Active"] = "ACTIVE";
    VmsProductSubscriptionStatusV2["Cancelled"] = "CANCELLED";
    VmsProductSubscriptionStatusV2["Paused"] = "PAUSED";
})(VmsProductSubscriptionStatusV2 = exports.VmsProductSubscriptionStatusV2 || (exports.VmsProductSubscriptionStatusV2 = {}));
var VmsProductType;
(function (VmsProductType) {
    VmsProductType["BookableProduct"] = "BOOKABLE_PRODUCT";
    VmsProductType["PlainProduct"] = "PLAIN_PRODUCT";
    VmsProductType["SubscriptionProduct"] = "SUBSCRIPTION_PRODUCT";
})(VmsProductType = exports.VmsProductType || (exports.VmsProductType = {}));
var VmsProductVisibility;
(function (VmsProductVisibility) {
    VmsProductVisibility["Hidden"] = "HIDDEN";
    VmsProductVisibility["Live"] = "LIVE";
})(VmsProductVisibility = exports.VmsProductVisibility || (exports.VmsProductVisibility = {}));
var VmsReportingCategory;
(function (VmsReportingCategory) {
    VmsReportingCategory["Alcohol"] = "Alcohol";
    VmsReportingCategory["Asian"] = "Asian";
    VmsReportingCategory["Bar"] = "Bar";
    VmsReportingCategory["Cafe"] = "Cafe";
    VmsReportingCategory["Catering"] = "Catering";
    VmsReportingCategory["Charging"] = "Charging";
    VmsReportingCategory["Chinese"] = "Chinese";
    VmsReportingCategory["Deals"] = "Deals";
    VmsReportingCategory["Desserts"] = "Desserts";
    VmsReportingCategory["Drinks"] = "Drinks";
    VmsReportingCategory["DryCleaning"] = "DryCleaning";
    VmsReportingCategory["Entertainment"] = "Entertainment";
    VmsReportingCategory["European"] = "European";
    VmsReportingCategory["Events"] = "Events";
    VmsReportingCategory["Facilities"] = "Facilities";
    VmsReportingCategory["Fashion"] = "Fashion";
    VmsReportingCategory["FastFood"] = "FastFood";
    VmsReportingCategory["Fitness"] = "Fitness";
    VmsReportingCategory["Flowers"] = "Flowers";
    VmsReportingCategory["FoodAndBeverage"] = "FoodAndBeverage";
    VmsReportingCategory["French"] = "French";
    VmsReportingCategory["Halal"] = "Halal";
    VmsReportingCategory["Health"] = "Health";
    VmsReportingCategory["Homeware"] = "Homeware";
    VmsReportingCategory["Italian"] = "Italian";
    VmsReportingCategory["Japanese"] = "Japanese";
    VmsReportingCategory["Kosher"] = "Kosher";
    VmsReportingCategory["Lockers"] = "Lockers";
    VmsReportingCategory["Mexican"] = "Mexican";
    VmsReportingCategory["Misc"] = "Misc";
    VmsReportingCategory["None"] = "None";
    VmsReportingCategory["Offers"] = "Offers";
    VmsReportingCategory["Parking"] = "Parking";
    VmsReportingCategory["Restaurant"] = "Restaurant";
    VmsReportingCategory["Salad"] = "Salad";
    VmsReportingCategory["Services"] = "Services";
    VmsReportingCategory["Soups"] = "Soups";
    VmsReportingCategory["SouthAmerican"] = "SouthAmerican";
    VmsReportingCategory["Sports"] = "Sports";
    VmsReportingCategory["Tickets"] = "Tickets";
    VmsReportingCategory["Wellness"] = "Wellness";
})(VmsReportingCategory = exports.VmsReportingCategory || (exports.VmsReportingCategory = {}));
var VmsSortOrder;
(function (VmsSortOrder) {
    VmsSortOrder["Asc"] = "ASC";
    VmsSortOrder["Desc"] = "DESC";
})(VmsSortOrder = exports.VmsSortOrder || (exports.VmsSortOrder = {}));
var VmsStepStatus;
(function (VmsStepStatus) {
    VmsStepStatus["Completed"] = "COMPLETED";
    VmsStepStatus["InProgress"] = "IN_PROGRESS";
    VmsStepStatus["Pending"] = "PENDING";
})(VmsStepStatus = exports.VmsStepStatus || (exports.VmsStepStatus = {}));
var VmsStoreUserPermission;
(function (VmsStoreUserPermission) {
    VmsStoreUserPermission["AccessReports"] = "ACCESS_REPORTS";
    VmsStoreUserPermission["CreateDealsVendor"] = "CREATE_DEALS_VENDOR";
    VmsStoreUserPermission["EditSiteSettings"] = "EDIT_SITE_SETTINGS";
    VmsStoreUserPermission["EditStoreSettings"] = "EDIT_STORE_SETTINGS";
    VmsStoreUserPermission["ManageDiscounts"] = "MANAGE_DISCOUNTS";
    VmsStoreUserPermission["ManageMenu"] = "MANAGE_MENU";
    VmsStoreUserPermission["ManageOrder"] = "MANAGE_ORDER";
    VmsStoreUserPermission["ManageUsers"] = "MANAGE_USERS";
    VmsStoreUserPermission["ManageVendors"] = "MANAGE_VENDORS";
    VmsStoreUserPermission["ManuallyAdjustOrder"] = "MANUALLY_ADJUST_ORDER";
    /** deprecated. Use MANUALLY_ADJUST_ORDER instead */
    VmsStoreUserPermission["RefundOrder"] = "REFUND_ORDER";
})(VmsStoreUserPermission = exports.VmsStoreUserPermission || (exports.VmsStoreUserPermission = {}));
var VmsSubscriptionBillingCycle;
(function (VmsSubscriptionBillingCycle) {
    VmsSubscriptionBillingCycle["Monthly"] = "MONTHLY";
    VmsSubscriptionBillingCycle["Weekly"] = "WEEKLY";
})(VmsSubscriptionBillingCycle = exports.VmsSubscriptionBillingCycle || (exports.VmsSubscriptionBillingCycle = {}));
var VmsSubscriptionPaymentStatus;
(function (VmsSubscriptionPaymentStatus) {
    VmsSubscriptionPaymentStatus["Failed"] = "FAILED";
    VmsSubscriptionPaymentStatus["PaymentPending"] = "PAYMENT_PENDING";
    VmsSubscriptionPaymentStatus["RequiresAction"] = "REQUIRES_ACTION";
    VmsSubscriptionPaymentStatus["Successful"] = "SUCCESSFUL";
})(VmsSubscriptionPaymentStatus = exports.VmsSubscriptionPaymentStatus || (exports.VmsSubscriptionPaymentStatus = {}));
var VmsVendorProductsSearchBy;
(function (VmsVendorProductsSearchBy) {
    VmsVendorProductsSearchBy["Description"] = "DESCRIPTION";
    VmsVendorProductsSearchBy["Name"] = "NAME";
})(VmsVendorProductsSearchBy = exports.VmsVendorProductsSearchBy || (exports.VmsVendorProductsSearchBy = {}));
var VmsVendorSortableFields;
(function (VmsVendorSortableFields) {
    VmsVendorSortableFields["Name"] = "NAME";
    VmsVendorSortableFields["Sites"] = "SITES";
    VmsVendorSortableFields["Status"] = "STATUS";
    VmsVendorSortableFields["StripeConnected"] = "STRIPE_CONNECTED";
})(VmsVendorSortableFields = exports.VmsVendorSortableFields || (exports.VmsVendorSortableFields = {}));
var VmsVendorVisibilityStatus;
(function (VmsVendorVisibilityStatus) {
    VmsVendorVisibilityStatus["Hidden"] = "HIDDEN";
    VmsVendorVisibilityStatus["Live"] = "LIVE";
})(VmsVendorVisibilityStatus = exports.VmsVendorVisibilityStatus || (exports.VmsVendorVisibilityStatus = {}));
var WebAppApplication;
(function (WebAppApplication) {
    WebAppApplication["Drupal"] = "DRUPAL";
    WebAppApplication["WebNg"] = "WEB_NG";
})(WebAppApplication = exports.WebAppApplication || (exports.WebAppApplication = {}));
var Weekday;
(function (Weekday) {
    Weekday["Fri"] = "FRI";
    Weekday["Mon"] = "MON";
    Weekday["Sat"] = "SAT";
    Weekday["Sun"] = "SUN";
    Weekday["Thu"] = "THU";
    Weekday["Tue"] = "TUE";
    Weekday["Wed"] = "WED";
})(Weekday = exports.Weekday || (exports.Weekday = {}));
var WhitelabelStatus;
(function (WhitelabelStatus) {
    WhitelabelStatus["AwaitingApproval"] = "AWAITING_APPROVAL";
    WhitelabelStatus["Developed"] = "DEVELOPED";
    WhitelabelStatus["Development"] = "DEVELOPMENT";
    WhitelabelStatus["DevelopmentBlocked"] = "DEVELOPMENT_BLOCKED";
    WhitelabelStatus["Draft"] = "DRAFT";
    WhitelabelStatus["Live"] = "LIVE";
    WhitelabelStatus["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    WhitelabelStatus["Retired"] = "RETIRED";
})(WhitelabelStatus = exports.WhitelabelStatus || (exports.WhitelabelStatus = {}));
var WorkRequestRole;
(function (WorkRequestRole) {
    WorkRequestRole["Service"] = "SERVICE";
})(WorkRequestRole = exports.WorkRequestRole || (exports.WorkRequestRole = {}));
exports.LocalePreferenceDocument = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query LocalePreference($userUuid: UUID, $siteUuid: UUID, $useViewer: Boolean) {\n  localePreference(\n    userUuid: $userUuid\n    destinationUuid: $siteUuid\n    useViewer: $useViewer\n  )\n}\n    "], ["\n    query LocalePreference($userUuid: UUID, $siteUuid: UUID, $useViewer: Boolean) {\n  localePreference(\n    userUuid: $userUuid\n    destinationUuid: $siteUuid\n    useViewer: $useViewer\n  )\n}\n    "])));
exports.StoreUserLocalePreferenceDocument = (0, graphql_tag_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    mutation StoreUserLocalePreference($locale: String) {\n  updateOwnLocalePreference(locale: $locale)\n}\n    "], ["\n    mutation StoreUserLocalePreference($locale: String) {\n  updateOwnLocalePreference(locale: $locale)\n}\n    "])));
function getSdk(requester) {
    return {
        LocalePreference: function (variables, options) {
            return requester(exports.LocalePreferenceDocument, variables, options);
        },
        StoreUserLocalePreference: function (variables, options) {
            return requester(exports.StoreUserLocalePreferenceDocument, variables, options);
        }
    };
}
exports.getSdk = getSdk;
var templateObject_1, templateObject_2;
